





































































































































































































































































































































































































































































































































































import VehicleChooserForCurrentCompany from '../../vehicles/components/VehicleChooserForCurrentCompany.vue';
import { ContextMenu } from '../../core/components';
import SetParameterValue from '../../settings/components/SetParameterValue.vue';
import TravelSettings from '../components/TravelSettings.vue';
import { DateRange as DataRangeComponent, Legend, Map, StatsInfo, VariableChart } from '../../core/components';
import { Component, Mixins, Provide, Watch } from 'vue-property-decorator';
import DeleteConfirmation from '../components/Geofences/DeleteConfirmation.vue';
import {
    AuthStoreHelper,
    getVehicleData,
    getVehiclePlateFromVehicleId,
    getVehicleVinById,
    NotificationStoreHelper,
    RootStoreHelper,
    StoreHelper,
    VehicleCompanyStoreHelper,
} from '../../core/mixins';
import StatisticsTable from '../components/StatisticsTable.vue';
import FleetSummaryTable from '../components/FleetSummaryTable.vue';
import DtcsFailuresTable from '../components/DtcsFailuresTable.vue';
import {
    DateRange,
    EventBus,
    formatDate,
    FilterDateEvent,
    getDateByFormat,
    getDateFromDateFormatApi,
    getDateTimeFromYesterday,
    getDateTimeToYesterday,
    getDateTimeToToDay,
    getDateTimeFromToDay,
    getHttpAxiosAsObservable,
    isVehicleStopped,
    getStateByNumber,
    hasElements,
    isEmptyObject,
    LegendMap,
    MarkerVehicleHistorical,
    MarkerVehicleHistoricalUUID,
    OptionalHistoricalData,
    OptionalVariableData,
    PlayBackInfo,
    PlaybackState,
    TypeEventBus,
    VehicleID,
    VisualizationApply,
    VisualizationInfo,
    isProductionMode,
    PRIVILEGE_KEYS,
    PRIVILEGE_TYPES,
    getDictionaryFromChoices,
    milisecondsToTime,
    parseFloatNumber,
    calculatePercentageOfNumber,
    getPositionsFiltered,
    TypeVehicleState,
    watchClass,
    getCurrentTime,
    getDateAsMoment,
    dateIsSameOrBefore,
    dateIsSameOrAfterSecond,
    getDateFormattedAsMoment,
    getNowNoFormat,
    addTimeToDate,
    getDiffBetweenDates,
    addItemToLocalStorage,
    StoregeKey,
    getIndexFromSimpleList,
    removeAccentsFromString,
    tableSort,
    getUniqueId,
    getIndexFromList,
    getValueWithCustomDecimals,
    getVehicleStateByNumberAsText,
    getIdsFromList,
    isNumber,
    removeItemFromLocalStorage,
    ID,
    getItemFromLocalStorage
} from '../../core/utils';
import { TrackingService, UserService } from '../../core/api';
import {
    Data,
    dateTypes,
    diffOptions,
    Filter,
    Geofence,
    HistoricalDataExcel,
    HistoricalDataResponse,
    HistoricalParams,
    LastReport,
    Marker,
    ParameterValue,
    Point,
    PointsOfInterest,
    Tracking,
    TypeFilterDate,
    VariablesResponse,
    Vehicle
} from '../../core/models';
import { uuid } from 'vue-uuid';
import { AddFilter, FilterDialog, FilterQuickAccess, FilterByVehicleState, NoCompaniesDialog, Travel, TravelInterval } from '../components';
import {
    buildCenterMapStep,
    buildFilterStep,
    buildGeoFenceStep,
    buildHideShowMarkersStep,
    buildLabelStep,
    buildPlayBackStep,
    buildSelectCompanyStep,
    buildSelectVehiclesStep,
    buildStatsInfoPanelStep,
    buildStatsPanelStep,
    buildStatsStep,
    buildUndoStep,
    buildYesterDayStep,
    centerVehicleInMap,
    getGeofenceError,
    getUnitByVarDescription,
    getVariableDescription,
    HistoricalMinute,
    LastReportFilters,
    speedVariables,
    tour,
    variablesSmartway,
    VariablesTypes
} from '../utils';
import { StatsPanel } from '../containers';
import multiselect from 'vue-multiselect';
import { Destroyed } from '../../core/decorators';
import { BehaviorSubject, combineLatest, merge, Observable, of, Subject, Subscription } from 'rxjs';
import { catchError, filter, map, pairwise, startWith, switchMap, takeUntil, tap } from 'rxjs/operators';
import { mapPosition, pluckAndStartWatch } from '../../core/operators';
import Loading from 'vue-loading-overlay';
import { chooseMarkerPositions, getBoundsFromPosition, parseSpeedValue } from '../../core/components/Map';
import GeofencesTab from '../components/Geofences/GeofencesTab.vue';
import rowItem from '../components/Table/rowItem.vue';
import { MarkStateStore } from '../components/Geofences/marks.state';
import { event } from 'vue-analytics';
import { format } from 'highcharts';
import Input from '../../core/components/Input.vue'; 
import SimpleTable from '../../core/components/SimpleTable.vue'; 
import ExportExcelButton from '../../core/components/ExportExcelButton.vue'; 
import CustomSwitch from '../../core/components/CustomSwitch.vue'; 
import { acopladoKey, ecuIsNotScannerMsg, ecuIsScanner } from '../../norms/utils';
import { SettingsService } from '../../settings/api/SettingsService';
import { HistoricalDtcsResponse, LastReportDtcsResponse } from '../api/LastReportDtcs';
import Axios, { CancelTokenSource } from 'axios';
import { settings } from 'cluster';
import { filterLastReportMarkers } from '../filters';
@Component<TrackingPage>({
    components: {
        ContextMenu,
        SetParameterValue,
        StatisticsTable,
        FleetSummaryTable,
        DtcsFailuresTable,
        GeofencesTab,
        DataRangeComponent,
        StatsPanel,
        Travel,
        Map,
        TravelInterval,
        StatsInfo,
        VariableChart,
        Loading,
        FilterDialog,
        rowItem,
        Legend,
        AddFilter,
        NoCompaniesDialog,
        FilterQuickAccess,
        FilterByVehicleState,
        multiselect,
        Input,
        SimpleTable,
        TravelSettings,
        ExportExcelButton,
        CustomSwitch,
        VehicleChooserForCurrentCompany,
        DeleteConfirmation
    },

    subscriptions() {
        return {
            pointsOfInterest$: this.pointStore.selected$,
            geoFences$: this.geoFencesStore.selected$,
            loadingPointsOfInterest$: this.pointStore.selectLoading(),
            loadingGeoFences$: this.geoFencesStore.selectLoading()
        };
    }
})
export default class TrackingPage extends Mixins(
    StoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    NotificationStoreHelper,
    AuthStoreHelper
) {
    //vars
    heightLoading: number = 100;
    thread: any = null;
    timeToExecuteLastReport = 15000;
    cancelLastReport: any = null;
    cancelTokenHistoricalData: any = null;
    cancelVariablesEnableByVehicles: any = null;
    cancelFilterByCompanies: any = null;
    cancelTokenHistoricalDataFromVisualizationApply: any = null;
    getCurrentTimestamp: any = null;
    drawer = false;
    searchedItems: string = '';
    pendingIndices: boolean = false;
    pendingDtcs: boolean = false;
    seeHeaders: boolean = false;
    showSamplingAlert: boolean = false;
    pendingRequestActualState: boolean = true;
    pendingRequestVariableData: boolean = true;
    varsKeys: any;
    varsValue: any;
    markersTravel: Marker[] = [];
    allPreviousMarkers: Marker[] = [];
    shouldTravelComponentDisplayed: boolean = false;
    shouldGeofenceComponentDisplayed: boolean = false;
    shouldShowLabelDisplayed: boolean = true;
    shouldStatsPanelDisplayed: boolean = false;
    shouldActualStatsPanelDisplayed: boolean = false;
    shouldShowRemoveSecondFilterButton: boolean = false;
    visibleTravelSettings: boolean = false;
    shouldNoCompaniesDialogDisplayed: boolean = false;
    marksPanelDisableListenKey: boolean = false;
    statsPanelIsMinimized: boolean = true;
    playbackState: string = PlaybackState.UNDEFINED;
    playbackSpeed: number = 500;
    selectionChartZoom: DateRange = {
        datetime_from: '',
        datetime_to: ''
    };
    filterDateEvent: FilterDateEvent | null = null; //Reverted because of bug | null;
    variables: OptionalVariableData = null;
    infos: Record<string, PlayBackInfo> = {};
    timeStampInfo: string | undefined = undefined;
    unSubscribe$: Subject<void> = new Subject<void>();
    historicalSubscription: Subscription | null = null;
    changesVehiclesByID$: BehaviorSubject<VehicleID[]> = new BehaviorSubject([]);
    ejecuteSearchHistorical$: Subject<void> = new Subject<void>();
    historicalDataSelection$: Observable<any>;
    markers: Marker[] = [];
    markerVehicleHistorical: MarkerVehicleHistoricalUUID[] = [];
    visualizationApply: VisualizationInfo = { markers: [], start: 0, end: -1 };
    paramsInfo: HistoricalParams | null = null;
    selectedParamsInfo: HistoricalParams | null = null;
    historicalDataExcel: HistoricalDataExcel = {};
    historicalExcelFileName: string = '';
    statsPanelTabClicked: string = '';
    historicalExcelSheets: string[] = [];
    historicalDtcFailures: HistoricalDtcsResponse = {};
    needToShowDtcFailures: boolean = false;
    needToRefreshDtcList: boolean = false;
    showDtcsInMap: boolean = false;
    historicalColumnsExcel: Array<object> = [
        {
            text: 'Latitud',
            align: '',
            value: 'lat'
        },
        {
            text: 'Longitud',
            align: '',
            value: 'lng'
        },
        {
            text: 'Velocidad',
            align: '',
            value: 'speed'
        },
        {
            text: 'Fecha y Hora',
            align: '',
            value: 'timestamp'
        }
    ]
    asyncSearch: boolean = false;
    shouldDisplayNoInformation: boolean = false;
    filters: Filter[] = [];
    pagination: object = {
        rowsPerPageItems: 12
    };
    currentFilter: Filter | null = null;
    isAddFilterVisible: boolean = false;
    zoomHistorical: number = 7;
    cancelFilerSelected: boolean = false;
    variableSelectedInPanel: boolean = false;
    variableResponse: Array<object> = [];
    @Provide() geoFencesStore: MarkStateStore<Geofence> = new MarkStateStore<Geofence>();
    @Provide() pointStore: MarkStateStore<PointsOfInterest> = new MarkStateStore<PointsOfInterest>();
    pointsOfInterest$: PointsOfInterest[];
    geoFences$: Geofence[];
    loadingPointsOfInterest$: boolean;
    loadingGeoFences$: boolean;
    addPointVisible: boolean = false;
    addGeoFenceVisible: boolean = false;
    mapClientHeight: number = 850;
    boundsCentered: google.maps.LatLngBounds | null = null;
    chartMin: number = -1; //position of the filter in the stats graph. -1 means no filter
    chartMax: number = -1;
    callLastReport: boolean = true;
    isFilterVehiclesClose: boolean = true;
    runSearchWhenFilterDateChange: boolean = true;
    selectedVehicle: boolean = true;
    vehiclesWithHistoricalData: any[] = [];
    lastReportResponse: any[] = [];
    lastReportDataIsFormated: boolean = false;
    clearSeriesInChart: boolean = false;
    stopMarkers: object = {};
    searchTableDebounceAstate: string = '';
    searchTable: string = '';
    itemsTableActualState: any = [];
    vehiclesList: any[] = [];
    isUpdatingLastReport: boolean = false;
    vehicleSelected: any = null;
    itemsTableFleetSummary: Array<object> = [];
    sortBy: string[] = ['variable', 'description'];
    sortDesc: boolean[] = [false, false];
    geofencesTypes: any = [];
    showLoader: boolean = true;
    visibleSetParameterValueModal: boolean = false;
    parameterValueToEdit: ParameterValue | null = null;
    vehicleProperties: object = {};
    //VariableData
    clearVehSelector: boolean = false;
    vehiclesListVarData: any[] = [];
    vehiclesSelectedVarData: any = null;
    itemsTable: any = [];
    hasParams: boolean = window.location.href.indexOf('?') !== -1 ? true : false;
    debounce: any = null;
    rangeSelectedIsValid: boolean = this.$_getIfRangeSelectedIsValid;
    getVehicleIndices: object = {};
    savedTimeSpentFilterNow: any = 0;
    historicalSampling: any | null = null;
    expandedPanel: boolean = false;
    boundsAreCero: boolean = false;
    existsInvalidPoints: boolean = false;
    pageMounted: boolean = false;
    contextMenuItem: any = [];
    rightClickEvent: any = null;
    showContextMenu: boolean = false;
    clickedRowActualState: object = {};
    vehicleToSetParameterValue: number = -1;
    showDtcFailures: boolean = false;
   requestTokenInstance: CancelTokenSource = Axios.CancelToken.source();
   summaryDeleteConfirmation: string[] = [];
    deleteParameterBody: string = '';
    confirmationDeleteParameter: boolean = false;
    summaryDeleteParameter: string[] = [];
    deleteParameterTitle: string = '';

    

    visibilityTravelSettings(value){
        this.visibleTravelSettings = value
    }

    openStopsSettings(){
        this.visibilityTravelSettings(true)
    }

     findHistoricalDtcs(){
        let self = this;
        this.pendingDtcs = false
        let selectedVehiclesIds = this.$_getSelectedVehiclesByID;
        let allVehiclesIds = getIdsFromList(this.$_getVehiclesFromSelectedCompany); 
        let vehiclesQuery = selectedVehiclesIds.length > 0 ? selectedVehiclesIds : allVehiclesIds;
        let params = {
            datetime_from: '',
            datetime_to: '',
        }
        if(this.requestTokenInstance){
            this.requestTokenInstance.cancel();
        }
        this.requestTokenInstance = Axios.CancelToken.source();
        if (this.$_getFilterDate == TypeFilterDate.TODAY) {
            params.datetime_from = getDateTimeFromToDay();
            params.datetime_to = getDateTimeToToDay();
        } else if (this.$_getFilterDate == TypeFilterDate.YESTERDAY) {
            params.datetime_from = getDateTimeFromYesterday();
            params.datetime_to = getDateTimeToYesterday();
        } else {
            params.datetime_from = this.$_getDateRange.datetime_from;
            params.datetime_to = this.$_getDateRange.datetime_to;
        }
         TrackingService.getHistoricalDtcs(
            params.datetime_from,
            params.datetime_to,
            this.requestTokenInstance,
            vehiclesQuery
        )
        .then((response: HistoricalDtcsResponse) => {
            this.assignHistoricalDtcs(response);

            setTimeout(() => {
                self.toggleDtcsInMap(true);
            }, 0);
        }).catch((error) => {
            this.$_catchLoadingDialog({
                response: error.response.data || {},
                alternative_msg: 'No se pudieron obtener los dtcs'
            });
        }).finally(() => {
            this.needToRefreshDtcList = false;
            this.pendingDtcs = false;
        })
    }

    resetHistoricalDtcs(){
        let vehiclesSelectedIds = this.$_getSelectedVehiclesByID;

        let dtcsList = {};

        vehiclesSelectedIds.forEach((vehicleId) => {
            dtcsList[vehicleId] = {
                dtcs: [],
                grouped_dtcs: [],
                vehicle_id: vehicleId
            };
        });

        this.historicalDtcFailures = dtcsList;
    }

    assignHistoricalDtcs(responseDtcs){
        let self = this;
        this.resetHistoricalDtcs();

        let dtcsInfo = {};

        if(responseDtcs.length > 0){
            responseDtcs.forEach((dtcInfo) => {
                let vehicleId = dtcInfo.vehicle_id;
                self.historicalDtcFailures[vehicleId] = dtcInfo;
            });
        }
    }



    toggleDtcFailures(){
        this.showDtcFailures = !this.showDtcFailures;

        if(!this.showDtcFailures){
            //si se ocultan los dtcs, oculto los dtcs en el mapa
            this.toggleDtcsInMap(false);
        }else{
            if(
                this.needToShowDtcFailures
            ){
                //si del WS historical_positions llega flag en true, muestro los dtcs en el mapa  
                //si la lista de dtcs esta vacia, busco los dtcs
                if(this.needToRefreshDtcList){
                    this.pendingDtcs = true;
                    this.findHistoricalDtcs();
                }else{
                    this.toggleDtcsInMap(true)
                }
            }
        } 
    }

    toggleDtcsInMap(visible: boolean){
        this.showDtcsInMap = visible;
    }

    

    showSetParameterValueModal(){
        this.visibilitySetParameterValueModal(true);
    }
    visibilitySetParameterValueModal(value){
        if(!value){
            this.vehicleToSetParameterValue = -1;
        }
        this.visibleSetParameterValueModal = value;
    }

    rightClickActualState(event, clickedRow){
        let vehicleHasVariableId = clickedRow['item'].hasOwnProperty('variable_id');
        let variableIdIsNumber = vehicleHasVariableId && isNumber(clickedRow['item']['variable_id']);

        if(this.$_getSmartwayMember){
            event.preventDefault();
            this.contextMenuItem = [];
            this.contextMenuItem.push(
                {
                    title: 'Setear valor',
                    openElement: 'set-parameter-value-modal',
                    disabled: !variableIdIsNumber,
                    tooltip: variableIdIsNumber ? 'Setear valor' : 'Esta entrada no se puede setear'
                },
                {
                    title: 'Eliminar entrada',
                    openElement: 'delete-parameter',
                    disabled: !vehicleHasVariableId,
                    tooltip: vehicleHasVariableId ? 'Eliminar entrada' : 'Esta entrada no se puede eliminar'
                }
            );
            this.vehicleToSetParameterValue = Number(clickedRow['item']['vehicle_id']);
            this.clickedRowActualState = clickedRow;
            this.rightClickEvent = event;
            this.showContextMenu = true;
        }
    }

    updateSearchValue(value){
        this.searchTable = value;
        this.debouncedOnChangeAstate(value);
    }

    pendingRequestVariableChart(val) {
        let statsPanel = this.$refs.statsTable as HTMLFormElement;
        if(statsPanel){
            statsPanel.pendingRequest(val);
        }
    }

    rangeSelectedUpdateValue(value) {
        this.$_setIfRangeSelectedIsValid(value);
    }

    get getExcelFileName(){
    let name = 'estado_actual_empresa_';
    if(this.$_getSelectedCompany){
        name += this.$_getSelectedCompany['name']
    }
    return name
   }

   handleStatsPanelTabClickedHistorical(tabName){
        if(tabName === 'Fallas'){
            let dtcsRef = this.$refs.historicalDtcsTable as HTMLFormElement;
            if (dtcsRef && typeof dtcsRef.getDtcsInfo === 'function') {
                dtcsRef.getDtcsInfo();
            }
        }
   }

   handleStatsPanelTabClickedNow(tabName){
        if(tabName === 'Fallas'){
            let dtcsRef = this.$refs.actualStateDtcsTable as HTMLFormElement;
            if (dtcsRef && typeof dtcsRef.getDtcsInfo === 'function') {
                dtcsRef.getDtcsInfo();
            }
        }
        
   }

   get getMapMarkers():Marker[]{
        let filteredIds:number[] = this.$_getFilteredLastReportVehicles;
        let markersToShow = [...this.markers];
        let lastReportFiltersElement = this.$refs.filtersLastReport as HTMLFormElement;
        if(lastReportFiltersElement){
            let lastReportFilters = lastReportFiltersElement.getLastReportFilters();
            let filteredMarks = filterLastReportMarkers(markersToShow, lastReportFilters);
            this.$_setFilteredLastReportVehicles(filteredMarks.filteredVehicleIds);
            markersToShow = filteredMarks.filteredMarkers.map(item => item);
        }
        
        return markersToShow
    }
   

    get getItemsActualState(){
        let filteredIds = this.$_getFilteredLastReportVehicles;

        // console.log("estado actual: deberia ver los filtrados")
        return  this.itemsTableActualState.filter(
            item => filteredIds.includes(Number(item.vehicle_id))
        ).map(item => item)
    }

    get getItemsPerPage(){
        return this.expandedPanel ? 50 : 30
    }

    get getHeadersTableActualState() {
        let headers: any = [
            {
                text: '',
                align: ' d-none',
                value: 'vehicle_plate',
                class: 'hide-header'
            },
            {
                text: 'Vehículo',
                align: 'left',
                value: 'vehicle_description',
                filter: this.filterByVehicle,
            },
            {
                text: 'Variable',
                align: 'left',
                value: 'variable'
            },
            {
                text: 'Valor',
                align: 'center',
                value: 'value'
            },
            {
                text: 'Ultimo mensaje',
                align: 'center',
                value: 'timestamp'
            }
        ];

        if (this.$_getSmartwayMember) {
            headers.push({
                text: 'Encabezado',
                align: 'center',
                value: 'headers',
                filter: this.filterByHeaders
            });
        }

        return headers;
    }

    getDefaultVariable(response) {
        if (response) return true;

        return false;
    }

    get getActualStateTableHeight() {
        if (this.expandedPanel) {
            return calculatePercentageOfNumber(this.mapClientHeight, 70);
        } else {
            return 390;
        }
    }

    get getStatsPanelHeight() {
        if (this.expandedPanel) {
            return calculatePercentageOfNumber(this.mapClientHeight, 88);
        } else {
            return 433;
        }
    }

    get getActualStatePanelHeight() {
        if (this.expandedPanel) {
            return calculatePercentageOfNumber(this.mapClientHeight, 85);
        } else {
            return 500;
        }
    }

    get getSamplingValue() {
        if (
            this.$_getVehicleHistoricalResponse &&
            this.$_getVehicleHistoricalResponse.sample_rate &&
            this.$_getVehicleHistoricalResponse.sample_rate !== 100
        ) {
            return parseFloatNumber(this.$_getVehicleHistoricalResponse.sample_rate) + '% ';
        } else {
            return '';
        }
    }

    get getGTMBtnCenterMap() {
        return !this.$store.state.userGroupSmartway ? 'ga_btn_center_map' : '';
    }

    get getGTMClassBtnHideShowPanelBrands() {
        if (!this.$store.state.userGroupSmartway) {
            return this.shouldGeofenceComponentDisplayed && this.drawer
                ? 'ga_btn_tracking_ocultar_panel_marcas'
                : 'ga_btn_tracking_mostrar_panel_marcas';
        } else {
            return '';
        }
    }

    get getGTMClassBtnHideShowPanelPlayback() {
        if (!this.$store.state.userGroupSmartway) {
            return !(this.shouldTravelComponentDisplayed && this.drawer)
                ? 'ga_btn_tracking_mostrar_panel_playback'
                : 'ga_btn_tracking_ocultar_panel_playback';
        } else {
            return '';
        }
    }

    filterByVehicle(vehicleDescription:string) {
        return this.vehicleSelected == null ? true : vehicleDescription === this.vehicleSelected['description'];
    }

    filterByHeaders(value) {
        value = value.toString();
        return this.seeHeaders ? true : value === 'No';
    }

    debouncedOnChangeAstate(value) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            this.searchTableDebounceAstate = value;
        }, 600);
    }

    handleStateMultiselect() {
        let value = null;
        this.debouncedOnChangeAstate(value);
    }

    resetMultiselectFilters() {
        this.clearVehicleSelected();
        this.searchTable = '';
        this.searchTableDebounceAstate = '';
    }

    handleVehicleSelectedInSelector(val) {
        this.vehicleSelected = val;
    }

    clearVehicleSelector() {
        this.clearVehSelector = true;
    }

    handleVariableSelected(val) {
        this.variableSelectedInPanel = val;
    }

    clearVehicleSelected(){
        this.vehicleSelected = null;
    }

    closeContextMenu() {
        this.showContextMenu = false;
    }

    contextMenuEvent(event){
        if(event === 'set-parameter-value-modal'){
            this.showParameterValueModal();
        }else if(event === 'delete-parameter'){
            this.deleteParameter();
        }
    }

    deleteParameter(){
        
        this.deleteParameterTitle = `Quitar entrada`
        this.deleteParameterBody = `¿Está seguro que desea quitar la entrada
        <b>${this.clickedRowActualState['item']['variable']}</b>  
        para el vehículo <b>${this.clickedRowActualState['item']['vehicle_description']}</b>?`
        this.confirmationDeleteParameter = true;
    }

    closeDeleteParameter(action){
         this.confirmationDeleteParameter = false;
        if (action) {
            this.deleteParameterBody = '';
            
            let vehicleId = this.clickedRowActualState['item']['vehicle_id'];
            let variableId = this.clickedRowActualState['item']['variable_id'];


            TrackingService.deleteParameterValueFromLastReport(
                vehicleId, 
                variableId
            ).then((response) => {
                this.$_successDeleteFilter(response.data.message);
                this.removeEntryFromActualStateTable();
            }).catch((error) => {
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudo eliminar el parámetro'
                });
            })
        }
    }

    removeEntryFromActualStateTable(){
        let indexToRemove = getIndexFromList(this.itemsTableActualState, 'id',  this.clickedRowActualState['item']['id']);
        if(indexToRemove !== -1){
            this.itemsTableActualState.splice(indexToRemove, 1);
        }
    }

    showParameterValueModal(){
        let clickedRowVehicleId = this.clickedRowActualState['item']['vehicle_id'];
        let clickedRowVariableId = this.clickedRowActualState['item']['variable_id'];
        let clickedRowEcuAddress = this.clickedRowActualState['item']['ecu_address'];
        let clickedRowValue = this.clickedRowActualState['item']['raw_value'];
        if(clickedRowVariableId !== undefined && ecuIsScanner(clickedRowEcuAddress)){
            this.parameterValueToEdit = {
                vehicle_id: clickedRowVehicleId,
                variable_id: clickedRowVariableId,
                value: clickedRowValue
            }
            this.showSetParameterValueModal();
        }else{
           this.$_showEmptyLastReport(ecuIsNotScannerMsg);
        }
    }

    updateParameterValueInActualStateRow(response, newValue){
        let self = this;
        let indexToUpdateValue = getIndexFromList(this.itemsTableActualState, 'id',  this.clickedRowActualState['item']['id']);
        if(indexToUpdateValue !== -1){
            this.$set(this.itemsTableActualState[indexToUpdateValue], 'value', newValue)
        }
    }

    //Actual state table
    clearFilter(item) {
        if (item === 'vehicleSelected') {
            this.clearVehicleSelected();
        }
    }

    customFilter(items, search, filter) {
        let userSearch = removeAccentsFromString(search.toString().toLowerCase());
        let filterVariable = removeAccentsFromString(filter.variable.toString().toLowerCase());
        let filterVariableDescription = removeAccentsFromString(filter.variable.toString().toLowerCase());
        let filterValue = removeAccentsFromString(filter.value.toString().toLowerCase());
        let filterTimeDiff = removeAccentsFromString(filter.time_diff.toLowerCase());

        return (
            filter.vehicle_description.includes(userSearch.toUpperCase()) ||
            filterVariableDescription.includes(userSearch) ||
            filterVariable.includes(userSearch) ||
            filterValue.includes(userSearch) ||
            filterTimeDiff.includes(userSearch)
        );
    }

    customSort(items: object[], sortBy: string[], sortDesc: boolean[]) {
        return tableSort(items, sortBy, sortDesc)
    }

    getTimeDiff(value, type: diffOptions){
        return addTimeToDate(getNowNoFormat(), value, type)  
    }
    getParseTime(time) {
        if (!time.match(/(\d+)/))
            return {
                measure: null,
                value: null
            };
        let timeValue = time.match(/(\d+)/)[0];
        let timeMeasure = time.substring(time.indexOf(' ') + 1);
        return {
            measure: timeMeasure,
            value: timeValue
        };
    }

    get getParamsInfo() {
        return this.paramsInfo;
    }

    get statsPanelVisibility() {
        if (this.$_getFilterDate === TypeFilterDate.TR && this.shouldActualStatsPanelDisplayed) {
            return true;
        } else {
            return false;
        }
    }

    get canReadFilters() {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.FILTERS, PRIVILEGE_TYPES.READ);
    }

    created() {
        this.pageMounted = false;
        this.clearVariableDataTab();
        this.vehiclesListVarData = [];
        this.getVehicleProperties();
        
    }

    getVehicleProperties(){
         SettingsService.getVehicleProperties().then((res) => {
            this.vehicleProperties = res;
        }).catch((res) => {

        })
    }

    finishTour() {
        this.$_setDateRange({
            datetime_to: '',
            datetime_from: ''
        });
        this.$_setTypeFilterDate(TypeFilterDate.TR);
        this.geoFencesStore.clear();
        this.pointStore.clear();
        UserService.tourState(true)
            .then(() => {
                this.$_setTour(true);
                this.$_setMock(false);
                // this.initCompaniesAndVariables();
                location.reload();
            })
            .catch(error => {
                if (error['message']) {
                    this.$_showFetchCompaniesError(error['message']);
                } else {
                    this.$_showFetchCompaniesError('Error terminando el tour');
                }
            });
    }



    @Watch('$route', { immediate: true, deep: true })
    onUrlChange(newVal: any) {
        this.checkIfExistAnyVehicleSelected();
        if (this.$_getFilterDate === TypeFilterDate.RANGE_DATE) {
            this.updateLocalStorageFilterNow();
            EventBus.$emit(TypeEventBus.FILTER_CHANGED);
            if (this.existAnyDataRange()) {
                this.showLoader = true;
            } else {
                if (this.pageMounted) {
                    this.$_showHistoricalError('No hay ningún rango de fecha seleccionado');
                    this.showLoader = false;
                }
            }
        } else if (this.$_getFilterDate === TypeFilterDate.TR) {
            this.setLocalStorageFilterNow();
            this.showLoader = true;
            this.callLastReport = true;
            this.executeSearch();
        } else {
            this.updateLocalStorageFilterNow();
            this.executeSearch();
        }
        if (this.hasParams) {
            this.checkDateRange();
        }

        this.loadDataGeoFences();
        this.loadPointsOfInterest();
    }

    setLocalStorageFilterNow() {
        this.savedTimeSpentFilterNow = new Date().getTime();
        //set actual date
        addItemToLocalStorage(StoregeKey.TIME_SPENT_FILTER_NOW, this.savedTimeSpentFilterNow)
    }

    updateLocalStorageFilterNow() {
        let actualDate = new Date().getTime();
        let daysDifference = actualDate - this.savedTimeSpentFilterNow;
        if (isProductionMode() && !this.$_getSmartwayMember) {
            event({
                eventCategory: 'Tiempo de permanencia',
                eventLabel: 'Travel - Filtros - Ahora: ' + milisecondsToTime(daysDifference),
                eventAction: 'Tiempo'
            });
        }
    }

    changedLastReportFilters(lastReportFilters: LastReportFilters) {
        if(this.allPreviousMarkers.length == 0){
            this.allPreviousMarkers = this.markers;
        }
        let {vehicleTypes, vehicleStates, filterWithRecentActivity } = lastReportFilters;
        let filteredIds:number[] = this.$_getFilteredLastReportVehicles;
        let markersToShow = this.allPreviousMarkers;

        let filteredMarks = filterLastReportMarkers(markersToShow, lastReportFilters);
        this.$_setFilteredLastReportVehicles(filteredMarks.filteredVehicleIds);
    }

    mounted() {
        let self = this;
        if (isProductionMode() && !this.$_getSmartwayMember) {
            window.addEventListener(
                'beforeunload',
                function(e) {
                    self.updateLocalStorageFilterNow();
                },
                false
            );
        }
        this.getVehicleIndices = {};
        if (this.$_getQueryParams['hasParams']) {
            this.checkDateRange();
        }
        this.formatVars();
        this.checkVehiclesSelected();
        this.resetDateRange();
        //save map client height
        let mapElement = this.$refs.map as HTMLFormElement;
        this.mapClientHeight = mapElement.$el.clientHeight;

        tour.addStep(buildSelectCompanyStep(this.finishTour));
        tour.addStep(buildCenterMapStep(this.finishTour));
        tour.addStep(buildLabelStep(this.finishTour));
        tour.addStep(buildHideShowMarkersStep(this.finishTour));
        tour.addStep(buildGeoFenceStep(this.finishTour));
        tour.addStep(
            buildSelectVehiclesStep(() => {
                this.$_setSelectedVehicles(['294']);
                this.changesVehiclesByID$.next(['294']);
                this.$_setTypeFilterDate(TypeFilterDate.YESTERDAY);
                this.$_setDateRange({
                    datetime_to: getDateTimeToYesterday(),
                    datetime_from: getDateTimeFromYesterday()
                });
                this.changeHistoricalParamsEffect();
                this.executeSearch();
            }, this.finishTour)
        );
        tour.addStep(
            buildYesterDayStep(() => {
                this.$_setSelectedVehicles([]);
                this.$_setTypeFilterDate(TypeFilterDate.TR);
                this.$_setDateRange({
                    datetime_to: '',
                    datetime_from: ''
                });
                this.changeHistoricalParamsEffect();
                this.executeSearch();
            }, this.finishTour)
        );
        tour.addStep(
            buildFilterStep(() => {
                //  this.filterQuickAccess.open();
            }, this.finishTour)
        );
        tour.addStep(
            buildStatsStep(() => {
                this.openStatsPanel();
                this.variableChart.disableAreaSelection();
            }, this.finishTour)
        );
        tour.addStep(
            buildStatsPanelStep(
                () => {
                    this.variableChart.filterMock();
                },
                () => {
                    this.$_closeStatsPanel();
                },
                this.finishTour
            )
        );

        tour.addStep(
            buildUndoStep(
                () => {
                    this.statsPanel.selectTab(1);
                },
                () => {
                    this.statsPanel.selectTab(0);
                    this.variableChart.resetSelection();
                },
                this.finishTour
            )
        );

        tour.addStep(
            buildStatsInfoPanelStep(
                () => {
                    this.$_closeStatsPanel();
                    this.handleTravel();
                },
                () => {
                    this.statsPanel.selectTab(0);
                },
                this.finishTour
            )
        );

        tour.addStep(
            buildPlayBackStep(() => {
                this.statsPanel.selectTab(1);
                this.openStatsPanel();
            }, this.finishTour)
        );

        EventBus.$on(TypeEventBus.TOGGLE_PANEL_MINIMIZED, payload => {
            this.statsPanelIsMinimized = payload;
        });

        EventBus.$on(TypeEventBus.VIEW_VEHICLE_IN_MAP_FROM_DTC_FAILS, this.showVehicleOnMapById)

        EventBus.$on(TypeEventBus.CLEAR_FILTER_DATE, payload => {
            this.rangeSelectedUpdateValue(false);
            this.clearHistoricalDtcs();
        });

        EventBus.$on(TypeEventBus.RANGE_SELECTED_VALID, payload => {
            this.rangeSelectedUpdateValue(payload);
        });

        EventBus.$on(TypeEventBus.CLOSE_DATEPICKER_POPUP, () => {
            if (this.existAnyDataRange()) {
                this.clearVariableDataTab();
                this.checkIfExistAnyVehicleSelected();
            }
        });

        EventBus.$on(TypeEventBus.NOT_CALL_LAST_REPORT, () => {
            this.callLastReport = false;
        });

        EventBus.$on(TypeEventBus.FILTER_VEHICLES_CLOSE, (vehicles: Vehicle[]) => {
            this.changesVehiclesByID$.next(vehicles.map(vehicle => vehicle.id));
            this.isFilterVehiclesClose = true;
            this.pollThread();
        });

        EventBus.$on(TypeEventBus.FILTER_VEHICLES_OPEN, () => {
            this.isFilterVehiclesClose = false;
            this.clearThread();
        });

        EventBus.$on(TypeEventBus.NUMBER_OF_DAYS_INVALID, () => {
            this.showLoader = false;
        });

        const selectedVehiclesByIDs$ = this.$watchAsObservable('$_getSelectedVehiclesByID').pipe(
            startWith({ oldValue: [], newValue: [] }),
            filter(({ oldValue, newValue }) => (oldValue as VehicleID[]).length > (newValue as VehicleID[]).length),
            map(({ oldValue, newValue }) => newValue),
            takeUntil(this.unSubscribe$)
        );

        const getVehiclesMarker$ = merge(selectedVehiclesByIDs$, this.changesVehiclesByID$)
            .pipe(
                pairwise(),
                filter(([oldValue, newValue]) => this.distinctUntilChangedVehiclesId(oldValue, newValue)),
                mapPosition(1),
                tap(() => this.changeHistoricalParamsEffect()),
                tap(() => {
                    //Reverted because of bug this.filterDateEvent = null;
                    if (this.$_getFilterDate === TypeFilterDate.TR) {
                        this.markers = [];
                    } else {
                        this.markerVehicleHistorical = [];
                        this.zoomHistorical = 7;
                    }
                    // this.filterQuickAccess.handleApplyVisualization(null, null);
                }),
                tap((vehiclesIds: VehicleID[]) => this.changeVehiclesByIDEffect(vehiclesIds)),
                takeUntil(this.unSubscribe$)
            )
            .subscribe();

        this.historicalDataSelection$ = this.ejecuteSearchHistorical$.pipe(
            tap(() => this.initSearchEffect()),
            filter(() => this.filterTrackingCondition()),
            tap(() => {
                this.asyncSearch = false;
                this.$_pendingHistoricalRequest();
            }),
            switchMap(() =>
                getHttpAxiosAsObservable(
                    TrackingService.getHistoricalDataByPositions(
                        this.paramsInfo,
                        this.cancelTokenHistoricalData,
                    ),
                    this.cancelTokenHistoricalData
                ).pipe(
                    catchError(error => {
                        this.showLoader = false;
                        // window.console.log(error);
                        this.$_completeHistoricalRequest();
                        // this.$_showHistoricalError(error.message);
                        return of(null);
                    })
                )
            ),
            tap((response: HistoricalDataResponse) => this.handleHistoricalResponse(response)),
            switchMap(() =>
                getHttpAxiosAsObservable(
                    TrackingService.getVariablesEnableByVehicles(
                        this.$_getSelectedVehiclesByID,
                        this.cancelVariablesEnableByVehicles,
                        this.$_getSelectedCompanyById as string
                    ),
                    this.cancelVariablesEnableByVehicles
                ).pipe(
                    catchError(error => {
                        this.showLoader = false;
                        this.$_completeHistoricalRequest();
                        // this.$_showHistoricalError(error.message);
                        return of([]);
                    })
                )
            ),
            tap((response: string[]) => this.handleVariablesResponse(response)),
            switchMap(() =>
                this.getLoadFilter$(
                    this.$_getSelectedCompanyById as string,
                    this.cancelFilterByCompanies,
                    this.$_isMock
                )
            ),
            takeUntil(this.unSubscribe$)
        );

        const setZoomAndCenter$ = this.ejecuteSearchHistorical$
            .pipe(
                filter(() => !this.existAnyVehiclesByID()),
                tap(() => {
                    this.mapSetZoomAndCenter([]);
                }),
                takeUntil(this.unSubscribe$)
            )
            .subscribe();

        const isFilterManagerVisible$ = this.$watchAsObservable('isFilterManagerVisible').pipe(
            pluckAndStartWatch(false)
        );

        const isAddFilterVisible$ = this.$watchAsObservable('isAddFilterVisible').pipe(pluckAndStartWatch(false));

        const marksPaneldisableListenKey$ = this.$watchAsObservable('marksPanelDisableListenKey').pipe(
            pluckAndStartWatch(false)
        );

        const addPointVisible$ = this.$watchAsObservable('addPointVisible').pipe(pluckAndStartWatch(false));
        const addGeoFenceVisible$ = this.$watchAsObservable('addGeoFenceVisible').pipe(pluckAndStartWatch(false));

        const disableListenKey$ = combineLatest([
            isFilterManagerVisible$,
            isAddFilterVisible$,
            marksPaneldisableListenKey$,
            addPointVisible$,
            addGeoFenceVisible$
        ])
            .pipe(takeUntil(this.unSubscribe$))
            .subscribe(
                ([
                    isFilterManagerVisible,
                    isAddFilterVisible,
                    isMarksPanelVisible,
                    addPointVisible,
                    addGeoFenceVisible
                ]) => {
                    if (
                        isFilterManagerVisible ||
                        isAddFilterVisible ||
                        isMarksPanelVisible ||
                        addPointVisible ||
                        addGeoFenceVisible
                    ) {
                        this.$_disableListenkey();
                    } else {
                        this.$_enableListenkey();
                    }
                }
            );
        this.pageMounted = true;
    }

    formatVars() {
        if (this.$_getVariables) {
            this.varsKeys = Object.keys(this.$_getVariables);
            this.varsValue = Object.values(this.$_getVariables);
        }
    }

    handleActualStatePanel(vehicle) {
        let vehicles;
        if (!this.$_getOpenStatsPanel) {
            this.shouldActualStatsPanelDisplayed = true;
            this.statsPanel.selectTab(0);
            this.openStatsPanel();
            this.statsPanel.toggleMinimizeState();
        }

        let vehicleId = vehicle.data.info.id.toString().split(', ');
        let vehiclePlate = vehicle.data.info.vehicle_plate.toString();

        //Ver si hay vehiculos seleccionados o si no hay ninguno seleccionado
        if (this.$_existVehiclesSelected()) {
            vehicles = this.$_getSelectedVehiclesByID;
        } else {
            vehicles = this.$_selectVehiclesFromSelectedCompanyById();
        }

        this.vehicleSelected = vehiclePlate;
        TrackingService.getLastReport(vehicles, false, this.$_isMock)
            .then((response: LastReport[]) => {
                
                this.updateActualStatePanel(response);
                this.showLoader = false;
                this.pendingRequestActualState = false;
            })
            .catch(error => {
                this.showLoader = false;
            });
    }


    clearVehiclesSelected() {
        this.clearFilter('vehicleSelected');
        this.variableChart.clearVehicleSelector();
    }

    mapSetZoomAndCenter(points) {
        if(this.map){
             this.map.setZoomAndCenterEffect(points);
        }
    }

    updateFleetSummaryPanel(currentRow, index) {
        let vehicle_id = currentRow['vehicle_id'];
        let vehicle_plate = getVehiclePlateFromVehicleId(vehicle_id, this.$_getVehiclesFromSelectedCompany)
        let vehicle_description = currentRow.vehicle_description || '-';
        let vehicle_normversion_id = currentRow.vehicle_normversion_id || '-';
        let location = currentRow.position.location || '-';
        let position = currentRow.position;
        let last_report = currentRow.position.timestamp || '-';
        let vehicle_state = currentRow.vehicle_state || '-';
        let driver_name = currentRow.driver_name || '-';
        let speed = parseSpeedValue(currentRow.speed.value);
        let last_message_time_diff = currentRow.last_message_time_diff;
        let itemToPush: object = {
            center_map: true,
            vehicle_id: vehicle_id,
            vehicle_plate: vehicle_plate,
            description: vehicle_description,
            nro_norma: vehicle_normversion_id,
            position: position,
            vin: getVehicleVinById(vehicle_id, this.$_getVehiclesFromSelectedCompany),
            last_report: formatDate(last_report),
            vehicle_state: vehicle_state,
            location: location,
            driver_name: driver_name,
            speed: speed,
            last_message_time_diff: last_message_time_diff,
            variable_report_performance:currentRow[VariablesTypes.PERFORMANCE],
            variable_report_humidity:  currentRow[VariablesTypes.HUMIDITY],
            variable_report_total_hours_operational: currentRow[VariablesTypes.TOTAL_HOURS_OPERATIONAL],
            variable_report_total_distance:  currentRow[VariablesTypes.TOTAL_DISTANCE],
            work_order_number: currentRow.work_order_number || '-',
            work_order_mount: currentRow.work_order_mount || '-',
            work_order_dest: currentRow.work_order_dest || '-',
            work_order_unload_date: currentRow.work_order_unload_date || '-',
            work_order_load_state: currentRow.work_order_load_state || 0,
            [acopladoKey]: currentRow[acopladoKey] || '-',
        };

        let smarwayColumns = ['sim_iccid', 'phone_number', 'tdu_exceptions', 'tdu_application', 'tdu_backup', 'tdu_bootloader', 'tdu_memory'];
        if(this.$_getSmartwayMember){
            itemToPush['sim_iccid'] = '-';
            itemToPush['phone_number'] = '-';
            itemToPush['tdu_exceptions'] = '-';
            itemToPush['tdu_application'] = '-';
            itemToPush['tdu_backup'] = '-';
            itemToPush['tdu_bootloader'] = '-';
            itemToPush['tdu_memory'] = '-';

            smarwayColumns.forEach((key) => {
                if(currentRow[key] != null && currentRow[key] != undefined){
                    itemToPush[key] = currentRow[key];
                }
            });
        }

        this.itemsTableFleetSummary.push(itemToPush);
    }

    updateActualStatePanel(response) {
        let self = this;
        this.itemsTableFleetSummary = [];
        this.itemsTableActualState = [];
        this.lastReportDataIsFormated = false;
        this.lastReportResponse = response;
        this.vehiclesList = [];
        if (!hasElements(response)) {
            // window.console.log("sin datos");
            this.getCurrentTimestamp = null;
        } else {
            this.getCurrentTimestamp = '';
            this.shouldActualStatsPanelDisplayed = true;
            
            for (let i = 0; i < response.length; i++) {
                let position = response[i]['position'];
                let tin = response[i]['tin'];
                if (tin !== undefined) {
                    response[i]['tin'] = {
                        is_header: true,
                        timestamp: '',
                        value: tin
                    };
                }
                let obj = Object.values(response[i]);
                let objKeys = Object.keys(response[i]);
                let vehicle_id = response[i]['vehicle_id'];
                let vehiclePlate = vehicle_id !== undefined ? this.getVehiclePlateFromVehicleId(vehicle_id) : '';
                if (vehiclePlate !== '') {
                    this.vehiclesList.push(vehiclePlate);
                }

                for (let b = 0; b < obj.length; b++) {
                    let data: any = obj[b];
                    
                    if (data && typeof data === 'object') {
                        let variableElement = getVariableDescription(objKeys[b]);
                        let variableIsHeader = data['is_header'] || false;

                         
                        let varDescription =
                            variableElement['description'] !== undefined
                                ? variableElement['description']
                                : variableElement;
                        let variableId =
                            data && data['variable_id'] !== undefined
                                ? data['variable_id']
                                : undefined;
                        let ecuAddress =
                            data && data['ecu_address'] !== undefined
                                ? data['ecu_address']
                                : undefined;
                        let unit =
                            variableElement['description'] !== undefined
                                ? getUnitByVarDescription(variableElement['description'], self.$_getVariables)
                                : '';
                           let itemValue =
                            variableElement === 'vehicle_state' || variableElement === 'Estado del Vehiculo'
                                ? typeof data === 'object' ? getVehicleStateByNumberAsText(data['value'], data['timestamp']) : '-'
                                : self.getValue(data);

                                if (variableElement['choices'] !== undefined) {
                            let formatChoices = JSON.stringify(variableElement['choices'])
                                .replace(/"/g, '')
                                .replace(/{/g, '')
                                .replace(/}/g, '')
                                .split(',');
                            if (itemValue !== '') {
                                if (objKeys[b] === 'crop_type') {
                                    if (formatChoices[itemValue] !== undefined) {
                                        itemValue = formatChoices[itemValue].replace(/=/, '').replace(itemValue, '');
                                    } else {
                                        itemValue = data['value'];
                                    }
                                } else {
                                    if (formatChoices[itemValue] !== undefined) {
                                        itemValue = formatChoices[itemValue].replace(/=/, '').replace(itemValue, '');
                                    } else {
                                        itemValue = '';
                                    }
                                }
                            } else {
                                itemValue = '';
                            }
                        } else {
                            if (unit !== '') {
                                itemValue = itemValue + ' ' + unit;
                            }
                        }
                        
                        let itemToPush: object = {
                            vehicle_plate: vehiclePlate,
                            vehicle_description: self.getVehicleDescriptionFromVehicleId(vehicle_id),
                            vehicle_id: vehicle_id,
                            variable: varDescription,
                            variable_id: variableId,
                            ecu_address: ecuAddress,
                            value: itemValue,
                            id: getUniqueId(),
                            timestamp: self.actualStateTimeStamp(data),
                            time_diff: data.time_diff || '-',
                            headers: variableIsHeader ? 'Si' : 'No',
                            position: position,
                            raw_value: data['raw_value']
                        };
                        if(varDescription !== VariablesTypes.SPEED){
                            if (self.$_getSmartwayMember) {
                                //Usuario smartway
                                self.pushItemToTableItems(itemToPush);
                            } else {
                                //Cliente
                                if (!variablesSmartway.includes(varDescription) && !variableIsHeader) {
                                    this.pushItemToTableItems(itemToPush);
                                }
                            }
                        }
                    }
                    
                }
                
                this.updateFleetSummaryPanel(response[i], i);
            }
           

            this.clearVehicleSelectorAfterLoadData();

            setTimeout(() => {
                this.getCurrentTimestamp = getCurrentTime(dateTypes.hoursAndMinutesAndSeconds)
            }, 500);
        }
    }

    actualStateTimeStamp(data) {
        if (data['timestamp'] !== '' || data['timestamp'] !== undefined) {
            return formatDate(data['timestamp'], true);
        } else {
            return '-';
        }
    }

    get shouldDisplayActualStateTable() {
        if (hasElements(this.lastReportResponse)) {
            return true;
        } else {
            return false;
        }
    }

    pushItemToTableItems(item) {
        this.itemsTableActualState.push(item);
    }

    getValue(data) {
        let value = data.value;
        if(value !== undefined){
            if(value == null){
                return '-'
            }
            if(Math.sign(value) !== -1) {
                //checkeo si el valor no es negativo
                return this.formatValue(value);
            } 
            if(Math.sign(value) == -1) {
                //si el numero es negativo
                return value;
            } 
        }
        
        if (data.location) {
            return data.location;
        } 
        if (data.lat && data.lng) {
            return 'lat:' + data.lat + ' , lng: ' + data.lng;
        }
         return '';
    }

    handleVariableNoInfo() {
        let statsPanel = this.$refs.statsTable as HTMLFormElement;
        if(statsPanel){
             statsPanel.displayNoInformationMsg();
        }
    }

    @Watch('paramsInfo')
    observableParamsInfo(params) {
        // console.log("params changed", params);
        if (this.drawer) {
            this.updatePlaybackIndices(params);
        }
    }


    getVehicleDescriptionFromVehicleId(id) {
        let vehicle_description = id;
        let indexVehicleId = this.$_getVehiclesFromSelectedCompany.findIndex(veh => veh.id == id);
        if(indexVehicleId !== -1){
            vehicle_description = this.$_getVehiclesFromSelectedCompany[indexVehicleId].description
        }
        return vehicle_description;
    }

    getVehiclePlateFromVehicleId(id) {
        let vehicle_plate;
        let indexVehicleId = this.$_getVehiclesFromSelectedCompany.findIndex(veh => veh.id == id);
        if(indexVehicleId !== -1){
            vehicle_plate = this.$_getVehiclesFromSelectedCompany[indexVehicleId].vehicle_plate
        }
        return vehicle_plate;
    }

    formatValue(item) {
         if (typeof item === 'number') {
            return getValueWithCustomDecimals(item);
        }

        if (typeof item === 'boolean' && item) {
            return 'activo';
        }
        if (typeof item === 'boolean' && !item) {
            return 'inactivo';
        } 
        return item.toString();
    }

    getLoadFilter$(selectedCompany: string, token: any, mock: boolean) {
        return getHttpAxiosAsObservable(
            TrackingService.getFilterByCompany(selectedCompany as string, token, mock),
            token
        ).pipe(
            tap((response: Filter[]) => this.handleFilterByCompanyResponse(response)),
            catchError(error => {
                this.$_completeHistoricalRequest();
                // this.$_showHistoricalError(error.message);
                return of([]);
            })
        );
    }

    filterTrackingCondition(): boolean {
        if (this.$_getFilterDate === TypeFilterDate.RANGE_DATE) {
            if (this.existAnyDataRange() && this.$_getIfRangeSelectedIsValid && this.existAnyVehiclesByID()) {
                return true;
            } else {
                return false;
            }
        } else {
            return this.existAnyVehiclesByID();
        }
    }

    clearHistoricalDtcs() {
        this.needToRefreshDtcList = true;
        this.toggleDtcsInMap(false);
        this.resetHistoricalDtcs()
        this.showDtcFailures = false;
    }

    

    initSearchEffect(): void {
        this.showSamplingAlert = false;
        this.needToRefreshDtcList = true;
        this.clearThread();
        this.cancelTokens();
        this.clearHistoricalDtcs();
        this.cancelTokenHistoricalData = Axios.CancelToken.source();
        this.cancelVariablesEnableByVehicles = Axios.CancelToken.source();
        this.cancelFilterByCompanies = Axios.CancelToken.source();
    }


    checkVehiclesSelected() {
        if (this.$_getFilterDate !== TypeFilterDate.TR) {
            if (this.$_getSelectedVehiclesByID.length > 3) {
                this.$_setSelectedVehicles([]);
            }
        }
    }

    showVehicleOnMapById(vehicleId: number){
        let self = this;
        let vehicle = this.getItemsActualState.find(function(item){
            return Number(item['vehicle_id']) == vehicleId
        })
        if(vehicle){
            let position = [{
                lat: vehicle['position']['latitude'], 
                lng: vehicle['position']['longitude']
            }]
            this.showVehicleInMap(
                position
            )
        }
    }

    setVehicleInMap(item){
        let position = [{
            lat: item.position.latitude, 
            lng: item.position.longitude
        }]
        this.showVehicleInMap(position);
    }

    showVehicleInMap(position) {
        let self = this;
        if( self.map && self.map.googleMap){
             centerVehicleInMap(
                position,
                self.map.googleMap,
                self.$_getOpenStatsPanel,
                self.mapClientHeight
            )
        }
       
    }

    checkDateRange() {

        let dateFrom = getDateAsMoment(this.$_getDateRange.datetime_from, dateTypes.globalFilterDateFormat)
        let dateTo = getDateAsMoment(this.$_getDateRange.datetime_to, dateTypes.globalFilterDateFormat)
        let daysDifference = 0;
        if (dateFrom > dateTo) {
            daysDifference = getDiffBetweenDates(dateTo, dateFrom, diffOptions.days)
        } else {
            daysDifference = getDiffBetweenDates(dateFrom, dateTo, diffOptions.days)
        }

        if (daysDifference > 7) {
            this.$_setDateRange({
                datetime_from: getDateFormattedAsMoment(dateFrom),
                datetime_to: getDateFormattedAsMoment(
                    addTimeToDate(dateFrom, 7, diffOptions.days),
                )
            });

        }
        EventBus.$emit(TypeEventBus.RANGE_SELECTED_VALID, true);
    }

    resetDateRange() {
        if (this.existAnyVehiclesByID()) {
            if (this.$_getFilterDate === TypeFilterDate.RANGE_DATE) {
                // window.console.log("fecha");
                if (this.existAnyDataRange()) {
                    this.setDateMounted(this.$_getDateRange.datetime_from, this.$_getDateRange.datetime_to);
                }
            } else if (this.$_getFilterDate === TypeFilterDate.TODAY) {
                // window.console.log("hoy");
                this.setDateMounted(getDateTimeFromToDay(), getDateTimeToToDay());
            } else if (this.$_getFilterDate === TypeFilterDate.TR) {
                // window.console.log("ahora");
                this.executeSearch();
            } else if (this.$_getFilterDate === TypeFilterDate.YESTERDAY) {
                // window.console.log("ayer");
                this.setDateMounted(getDateTimeFromYesterday(), getDateTimeToYesterday());
            }
        }
    }

    setDateMounted(from, to) {
        this.$_setDateRange({
            datetime_from: '',
            datetime_to: ''
        });
        this.$_setDateRange({
            datetime_from: from,
            datetime_to: to
        });
    }

    existAnyDataRange(): boolean {
        return !!(this.$_getDateRange.datetime_from && this.$_getDateRange.datetime_to);
    }

    existAnyVehiclesByID(): boolean {
        return !!(this.$_getSelectedVehiclesByID && this.$_getSelectedVehiclesByID.length);
    }

    setLoadingTravel(value) {
        this.showLoader = value;
    }

    setHistoricalDataExcel(response: HistoricalDataResponse){
        let trackingData: HistoricalDataResponse["tracking"] = response.tracking;
        let jsonData:HistoricalDataExcel = {}
        let self = this;
        
        for (let index = 0; index < trackingData.length; index++) {
            const currentVehicle = trackingData[index];
            const vehicleId = currentVehicle.vehicle_id;
            const vehicleData = currentVehicle['data'];
            const vehicleDescription = self.getVehicleDescriptionFromVehicleId(vehicleId);
            this.historicalExcelSheets.push(vehicleDescription);
            jsonData[vehicleDescription] = vehicleData.map(function(item){
                return {
                    lat: item.lat,
                    lng: item.lng,
                    speed: item.speed,
                    timestamp: item.timestamp
                }
            });
        }
        
        let fileName = 'Recorrido';
        fileName += `[${this.historicalExcelSheets.join(', ')}]`;
        if(this.paramsInfo){
            fileName += `_inicio=${this.paramsInfo.datetime_from}--`
            fileName += `fin=${this.paramsInfo.datetime_to}_`
        }
        if(this.$_getSelectedCompany){
            fileName += `_${this.$_getSelectedCompany.name}`  
        }
        this.historicalExcelFileName = fileName;
        this.historicalDataExcel = jsonData;
    }

    handleHistoricalResponse(result: any): void {
        this.historicalDataExcel = {};
        this.historicalExcelSheets = [];
        if (result) {
            this.needToShowDtcFailures = result.has_dtc_fails;
            this.clearVariableDataTab();
            this.showLoader = false;
            this.setHistoricalDataExcel(result);
            this.$_completeHistoricalRequest();
            this.checkEmptyHistoricalData(result);
            this.playbackState = PlaybackState.UNDEFINED;
            this.markersTravel = [];
            this.$_setHistoricalMap(result);
            this.changeHistoricalMarkersEffect();
            this.checkIfExistsInvalidPoints(result);
            this.filterQuickAccess.updateVisualizationApplied();
        }
    }

    checkIfExistsInvalidPoints(response) {
        let value = false;
        if (!response['sampled']) {
            let points_count = response['points_count'];
            let tracking_positions = response['tracking'].length;
            let valid_positions = 0;
            for (let index = 0; index < tracking_positions; index++) {
                valid_positions = valid_positions + response['tracking'][index]['data'].length;
            }

            let points_invalid = points_count - valid_positions;
            if (points_invalid > 0 && valid_positions > 0) {
                //Usuario Smartway
                //Se están visualizando el % de las posiciones
                if (this.$_getSmartwayMember) {
                    let percentage_visible_points = Math.round((points_invalid * 100) / points_count);
                    if (!this.showSamplingAlert && percentage_visible_points > 20) {
                        this.$_showEmptyLastReport(
                            'Se están visualizando el ' + percentage_visible_points + '% de las posiciones'
                        );
                    }
                }
                //Cliente no ve ningún mensaje
                value = true;
            } else if (points_count > 0 && tracking_positions == 0) {
                this.$_showEmptyLastReport('No hay posiciones válidas para mostrar');
                value = true;
            } else {
                value = false;
            }
        }

        if (value) {
            this.shouldStatsPanelDisplayed = true;
            this.shouldShowRemoveSecondFilterButton = false;
            this.selectedParamsInfo = null;
        }
    }

    get showAlertSampling() {
        if (this.$_getVehicleHistoricalResponse !== null) {
            if (
                this.$_getVehicleHistoricalResponse['sample_rate'] &&
                this.$_getVehicleHistoricalResponse['sample_rate'] !== 100
            ) {
                this.showSamplingAlert = true;
                return true;
            } else {
                this.showSamplingAlert = false;
                return false;
            }
        } else {
            this.showSamplingAlert = false;
            return false;
        }
    }

    removeVariableFromDataTab(variable) {
        this.deleteVariableFromDataTab(variable);
        let statsPanel = this.$refs.statsTable as HTMLFormElement;
        if(this.statisticsPanel){
            statsPanel.setVariableSelected(null);
        }
    }

    updateDatosWithSelection(selection) {
        let dateFrom =
            selection.datetime_from === '' ? selection.datetime_from : formatDate(selection.datetime_from, true);
        let dateTo = selection.datetime_to === '' ? selection.datetime_to : formatDate(selection.datetime_to, true);

        this.selectionChartZoom = {
            datetime_from: dateFrom,
            datetime_to: dateTo
        };
        this.reloadVariableDataTable();
    }

    reloadVariableDataTable() {
        let statsPanel = this.$refs.statsTable as HTMLFormElement;
        if(statsPanel){
            statsPanel.reloadAnimation();
        }
    }

    clearVariableDataTab() {
        let statsPanel = this.$refs.statsTable as HTMLFormElement;
        if(statsPanel){
            statsPanel.clearVariableDataTab()
            this.variableResponse = [];
        }
    }

    updateVariableDataTab(response, variable) {
        let statisticsPanel = this.$refs.statsTable as HTMLFormElement;
        if(statisticsPanel){
            this.variableResponse = response;
            statisticsPanel.updateVariableData(response, variable);
        }
        this.clearVehicleSelectorAfterLoadData();
    }
        
    clearVehicleSelectorAfterLoadData() {
        if (this.clearVehSelector) {
            this.clearFilter('vehicleSelected');
            this.clearVehSelector = false;
        }
    }

    deleteVariableFromDataTab(variable){
        let statsPanel = this.$refs.statsTable as HTMLFormElement;
        if(statsPanel){
            statsPanel.deleteVariableFromDataTab(variable);
        }
    }

    existHistoricalData(): boolean {
        return this.shouldStatsPanelDisplayed && this.shouldTravelComponentDisplayed;
    }

    handleFilterByCompanyResponse(result: Filter[]): void {
        this.filters = result;
        this.$_completeHistoricalRequest();
    }

    handleRemoveFilter(ids: string[]): void {
        this.filters = this.filters.filter(filter => getIndexFromSimpleList(ids, filter.id) < 0);
    }

    changeVehiclesByIDEffect(vehiclesIds: VehicleID[]): void {
        this.resetZoomAndCenter();
        this.$_clearHistoricalMap();
        this.variables = null;
        this.shouldTravelComponentDisplayed = false;
        if (this.$_getFilterDate === TypeFilterDate.TR || hasElements(vehiclesIds)) {
            this.executeSearch();
        }
    }

    changeVehiclesMarkerEffect(): void {
        if (this.$_getFilterDate === TypeFilterDate.TR) {
            this.markers = this.$_selectVehiclesMarker();
        } else {
            this.markers = [];
        }
    }

   

   calculeSetCenterAndZoom(markers: Marker[] | MarkerVehicleHistoricalUUID[]): void {
        let isThereFilteredInfo = false;
        let selectedMarkers = this.getHistoricalMarkers(this.filterDateEvent);
        selectedMarkers.forEach(hm => {
            if (hm && hm.markers && hm.start != undefined && hm.end) {
                if (hm.start < hm.end) {
                    if (hm.start != 0 || hm.end != hm.markers.length - 1) {
                        isThereFilteredInfo = true;
                    }
                    hm.markers = hm.markers.slice(hm.start, hm.end + 1);
                } else {
                    isThereFilteredInfo = true;
                    hm.markers = [];
                }
            }
        });
        let points = chooseMarkerPositions(selectedMarkers);
        google.maps.event.addListenerOnce(this.map.googleMap, 'bounds_changed', () => {
            this.zoomHistorical = this.map.googleMap.getZoom();
            this.map.googleMap.setZoom(this.zoomHistorical);
            this.markerVehicleHistorical = markers as MarkerVehicleHistoricalUUID[];
            this.setStops();
            if (!isThereFilteredInfo) {
                this.shouldShowRemoveSecondFilterButton = false;
            } else {
                this.shouldShowRemoveSecondFilterButton = true;
            }
        });
        if (hasElements(points)) {
            let mapElement = this.$refs.map as HTMLFormElement;
            this.mapClientHeight = mapElement.$el.clientHeight;
            let bounds: google.maps.LatLngBounds = this.getHistoricalBounds(points);
            this.boundsCentered = bounds;
            this.map.googleMap.setCenter(bounds.getCenter());
            this.map.googleMap.fitBounds(bounds);
        } else {
            isThereFilteredInfo = true;
            this.showNoInfoMessage();
            this.mapSetZoomAndCenter(points);
        }
    }

    getHistoricalBounds(points: Point[]): google.maps.LatLngBounds {
        return getBoundsFromPosition(points, this.$_getOpenStatsPanel, this.mapClientHeight);
    }

    handleFocusCenter(): void {
        this.map.clickBtnCenter();
    }

    handleChangeBoundsCentered(bound: google.maps.LatLngBounds) {
        this.boundsCentered = bound;
    }

    centerHistorical(): void {
        let selectedMarkers = this.getHistoricalMarkers(this.filterDateEvent);
        selectedMarkers.forEach(hm => {
            if (hm && hm.markers && hm.start != undefined && hm.end) {
                if (hm.start < hm.end) {
                    hm.markers = hm.markers.slice(hm.start, hm.end + 1);
                } else {
                    hm.markers = [];
                }
            }
        });
        // old > let points = chooseMarkerPositions(selectedMarkers);
        let points = selectedMarkers.length > 0 ? selectedMarkers[0]['markers'] : [];
        let mapElement = this.$refs.map as HTMLFormElement;
        this.mapClientHeight = mapElement.$el.clientHeight;
        // let bounds = getBoundsFromPosition(points, this.$_getOpenStatsPanel, this.mapClientHeight);
        let bounds: any = this.getHistoricalBounds(points);
        this.boundsCentered = bounds;
        this.map.googleMap.setCenter(bounds.getCenter());
        this.map.googleMap.fitBounds(bounds);
    }

    changeHistoricalMarkersEffect(): void {
        if (this.$_getFilterDate !== TypeFilterDate.TR && hasElements(this.$_getSelectedVehiclesByID)) {
            if (this.filterDateEvent) {
                this.calculeSetCenterAndZoom(this.getHistoricalMarkers(this.filterDateEvent));
            } else {
                this.calculeSetCenterAndZoom(this.getHistoricalMarkers());
            }
        } else {
            this.markerVehicleHistorical = [];
            this.zoomHistorical = 7;
        }
    }

    changeSelectedHistoricalParamsEffect(filterDateEvent: FilterDateEvent): void {
        if (filterDateEvent && filterDateEvent.range) {
            this.selectedParamsInfo = {
                company_id: this.$_getSelectedCompanyById as string,
                datetime_from: filterDateEvent.range.datetime_from,
                datetime_to: filterDateEvent.range.datetime_to,
                vehicles:
                    this.$_getSelectedVehiclesByID && this.$_getSelectedVehiclesByID.length
                        ? this.$_getSelectedVehiclesByID.join(',')
                        : ''
            };
        }
    }

    resetVariableDataItems() {
        EventBus.$emit(TypeEventBus.GET_HISTORICAL_DATA_BY_PARAMETERS_STATS, this.$_getDateRange);
    }

    changeHistoricalParamsEffect(): void {
        if (this.$_getFilterDate == TypeFilterDate.TODAY) {
            this.paramsInfo = {
                datetime_from: getDateTimeFromToDay(),
                datetime_to: getDateTimeToToDay(),
                limit: false,//aca
                company_id: this.$_getSelectedCompanyById as string,
                vehicles:
                    this.$_getSelectedVehiclesByID && this.$_getSelectedVehiclesByID.length
                        ? this.$_getSelectedVehiclesByID.join(',')
                        : ''
            };
        } else if (this.$_getFilterDate == TypeFilterDate.YESTERDAY) {
            this.paramsInfo = {
                datetime_from: getDateTimeFromYesterday(),
                datetime_to: getDateTimeToYesterday(),
                limit: false,
                company_id: this.$_getSelectedCompanyById as string,
                vehicles:
                    this.$_getSelectedVehiclesByID && this.$_getSelectedVehiclesByID.length
                        ? this.$_getSelectedVehiclesByID.join(',')
                        : ''
            };
        } else {
            if (this.$_getDateRange.datetime_from !== '' && this.$_getDateRange.datetime_to !== '') {
                this.paramsInfo = {
                    datetime_from: this.$_getDateRange.datetime_from,
                    datetime_to: this.$_getDateRange.datetime_to,
                    limit: true,
                    company_id: this.$_getSelectedCompanyById as string,
                    vehicles:
                        this.$_getSelectedVehiclesByID && this.$_getSelectedVehiclesByID.length
                            ? this.$_getSelectedVehiclesByID.join(',')
                            : ''
                };
            }
        }
    }

    distinctUntilChangedVehiclesId(oldValue: VehicleID[], newValue: VehicleID[]): boolean {
        let distinct: boolean = false;
        if (oldValue.length !== newValue.length) {
            distinct = true;
        } else {
            for (let i = 0; i < oldValue.length; i++) {
                if (oldValue[i] !== newValue[i]) {
                    distinct = true;
                    break;
                }
            }
        }
        return distinct;
    }

    clearSelectionChartZoom(){
        this.selectionChartZoom = {
            datetime_from: '',
            datetime_to: ''
        }
    }

    handleRemoveSecondFilter() {
        EventBus.$emit(TypeEventBus.RESET_STATS_ZOOM);
        this.clearSelectionChartZoom()
        this.markerVehicleHistorical.forEach(mvh => {
            mvh.start = 0;
            mvh.end = mvh.markers.length - 1;
        });
        this.shouldShowRemoveSecondFilterButton = false;

        if (this.playbackState == PlaybackState.PLAY) {
            this.handleChangeIntervalState(PlaybackState.STOP);
        }
        this.selectedParamsInfo = null;
    }

    updateVehiclesParamsInfo(vehicles) {
        if(vehicles === undefined || vehicles == -1){
            return
        }

        if (this.paramsInfo && vehicles) {
            this.paramsInfo.vehicles = vehicles.toString();
        }
    }

    handleChangeFilter(filterDateEvent: FilterDateEvent, chartMin: number, chartMax: number) {
        let triggerChangeHistoricalMarkers: boolean = true;
        if (!filterDateEvent && !this.filterDateEvent) {
            triggerChangeHistoricalMarkers = false;
        }
        this.chartMin = chartMin;
        this.chartMax = chartMax;
        this.filterDateEvent = filterDateEvent;

        if (triggerChangeHistoricalMarkers) {
            if (hasElements(this.visualizationApply.markers)) {
                this.visualizationApply = this.buildAndFilterVisualizationApply(
                    this.visualizationApply.markers,
                    filterDateEvent
                );
                this.centerVisualization(this.visualizationApply);
                this.validateVisualization(this.visualizationApply);
            } else {
                this.changeHistoricalMarkersEffect();
            }
        }
        this.updateDatosTable(chartMin, chartMax);
        this.changeSelectedHistoricalParamsEffect(filterDateEvent);
    }


    updateDatosTable(min, max){
        if (this.filterDateEvent !== null && min !== -1 && max !== -1) {
            this.updateDatosWithSelection(this.filterDateEvent.range);
        } else {
            let dateFrom;
            let dateTo;
            if (this.$_getFilterDate == TypeFilterDate.TODAY) {
                dateFrom = getDateTimeFromToDay();
                dateTo = getDateTimeToToDay();
            } else if (this.$_getFilterDate == TypeFilterDate.YESTERDAY) {
                dateFrom = getDateTimeFromYesterday();
                dateTo = getDateTimeToYesterday();
            } else {
                if (this.$_getDateRange.datetime_from !== '' && this.$_getDateRange.datetime_to !== '') {
                    dateFrom = this.$_getDateRange.datetime_from;
                    dateTo = this.$_getDateRange.datetime_to;
                }
            }
            this.updateDatosWithSelection({
                datetime_from: dateFrom,
                datetime_to: dateTo
            });
        }
    }

    handleChangeIntervalState(state: string) {
        if (state !== PlaybackState.UNDEFINED) {
            this.markersTravel = [];
        }
        if (state === PlaybackState.PLAY) {
            if (this.playbackState === PlaybackState.PAUSE) {
                this.centerHistorical();
            } else {
                this.changeHistoricalMarkersEffect();
            }
        }
        if (state === PlaybackState.STOP) {
            this.changeHistoricalMarkersEffect();
        }
        this.playbackState = state;
    }

    get getGtmIdHideShowTags() {
        if (!this.$store.state.userGroupSmartway) {
            if (this.$_getShowLabel) {
                return 'ga_btn_tracking_ocultar_etiquetas';
            } else {
                return 'ga_btn_tracking_mostrar_etiquetas';
            }
        } else {
            return '';
        }
    }

    get getGTMClassButtonShowHideBrands() {
        if (!this.$store.state.userGroupSmartway) {
            return this.existAnyElementVisible ? 'ga_btn_tracking_ocultar_marcas' : 'ga_btn_tracking_mostrar_marcas';
        } else {
            return '';
        }
    }

    get statisticsPanel(): HTMLFormElement {
        return this.$refs.statsTable as HTMLFormElement
    }

    get fleetSummaryPanel(): HTMLFormElement {
        return this.$refs.fleetSummaryComponent as HTMLFormElement
    }

    get statsPanel(): HTMLFormElement {
        return this.$refs.statsPanel as HTMLFormElement;
    }

    get map(): HTMLFormElement {
        return this.$refs.map as HTMLFormElement;
    }

    handleChangeSpeed(speed: number) {
        this.playbackSpeed = speed;
    }

    showNoInfoMessage() {
        this.$_showEmptyLastReport('No hay información para el período seleccionado');
    }

    checkEmptyLastReport(response: LastReport[]): void {
        if (!hasElements(response)) {
            this.showNoInfoMessage();
            this.shouldActualStatsPanelDisplayed = false;
            this.pendingRequestActualState = false;
            // this.$_closeStatsPanel();
        } else {
            let flag = true;
            this.boundsAreCero = false;
            response.forEach(lastReport => {
                if (lastReport.position) {
                    flag = false;
                    if (lastReport.position['latitude'] == 0 && lastReport.position['longitude'] == 0) {
                        this.boundsAreCero = true;
                    }
                }
            });
            if (flag) {
                this.showNoInfoMessage();
                this.shouldActualStatsPanelDisplayed = false;
                this.$_closeStatsPanel();
            }
        }
    }

    markersBinarySearchStart(markers: Marker[], length: number, date: Date) {
        let l = 0;
        let r = length;

        while (l < r) {
            let m = Math.floor((l + r) / 2);
            let marker = markers[m];
            if (marker.infoState && marker.infoState.timestamp) {
                let dateTime = getDateFromDateFormatApi(marker.infoState.timestamp);
                if (dateTime < date) {
                    l = m + 1;
                } else {
                    r = m;
                }
            } else {
                return 0;
            }
        }
        return l;
    }

    markersBinarySearchEnd(markers: Marker[], length: number, date: Date) {
        let l = 0;
        let r = length;

        while (l < r) {
            let m = Math.floor((l + r) / 2);
            let marker = markers[m];
            if (marker.infoState && marker.infoState.timestamp) {
                let dateTime = getDateFromDateFormatApi(marker.infoState.timestamp);
                if (dateTime > date) {
                    r = m;
                } else {
                    l = m + 1;
                }
            } else {
                return length - 1;
            }
        }
        return l - 1;
    }

    findStartFilter(markers: Marker[], filterDateEvent: FilterDateEvent): number {
        if (filterDateEvent && filterDateEvent.range) {
            const fromDate = getDateFromDateFormatApi(filterDateEvent.range.datetime_from);
            return this.markersBinarySearchStart(markers, markers.length, fromDate);
        } else {
            return markers.length - 1;
        }
    }

    findEndFilter(markers: Marker[], filterDateEvent: FilterDateEvent): number {
        if (filterDateEvent && filterDateEvent.range) {
            const toDate = getDateFromDateFormatApi(filterDateEvent.range.datetime_to);
            return this.markersBinarySearchEnd(markers, markers.length, toDate);
        } else {
            return markers.length - 1;
        }
    }

    getHistoricalMarkers(filterDateEvent?: FilterDateEvent | null) {
        const vehicleHistorical: MarkerVehicleHistorical = this.$_selectVehicleHistorical(
            this.$_getFilterDate === TypeFilterDate.TR
        );
        const vehicleHistoricalKeys: string[] = Object.keys(vehicleHistorical);
        const result = vehicleHistoricalKeys.map((key, index) => {
            let vehicleId = Number(key);
            if (filterDateEvent) {
                return {
                    markers: getPositionsFiltered(vehicleHistorical[key]),
                    id: String(uuid.v1()),
                    start: this.findStartFilter(vehicleHistorical[key], filterDateEvent),
                    end: this.findEndFilter(vehicleHistorical[key], filterDateEvent),
                    color: vehicleHistorical[key][index]['color'],
                    vehicle_id: vehicleId
                };
            } else {
                return {
                    markers: getPositionsFiltered(vehicleHistorical[key]),
                    id: String(uuid.v1()),
                    start: 0,
                    end: vehicleHistorical[key].length - 1,
                    color: vehicleHistorical[key][index]['color'],
                    vehicle_id: vehicleId
                };
            }
        });
        return result;
    }

    buildMarkerTravel(id: string, data: any): Marker[] {
        return data.map(data => {
            return {
                lat: data.lat,
                lng: data.lng,
                infoState: {
                    state: getStateByNumber(
                        data.vehicle_state,
                        data.timestamp,
                        this.$_getFilterDate === TypeFilterDate.TR
                    ),
                    speed: data.speed,
                    identification: this.$_getVehiclesMap[id],
                    timestamp: data.timestamp
                },
                info: this.$_getVehiclesMap[id],
                icon: {
                    rotation: +data.rotation,
                    path: ''
                }
            };
        });
    }

    handleSelectMinute(minute: HistoricalMinute) {
        if (this.$_getVehicleHistoricalResponse) {
            let positions: { [id: string]: Data[] } = this.filterDataByTrackingArray(
                this.$_getVehicleHistoricalResponse.tracking,
                minute.value
            );
            this.markersTravel = Object.keys(positions).reduce((accu, it) => {
                return [...accu, ...this.buildMarkerTravel(it, positions[it])];
            }, []);
            this.playbackState = PlaybackState.UNDEFINED;
            this.map.setCenter(this.getOnlyPositions(positions));
        }
    }

    getOnlyPositions(positionsMap: { [id: string]: Data[] }): Point[] {
        let points: Point[] = [];
        Object.values(positionsMap).forEach((data: any) => {
            data.forEach(dt => {
                points.push({ lng: dt.lng, lat: dt.lat });
            });
        });
        return points;
    }

    filterDataByTrackingArray(tracking: Tracking[], documentIds: string[]): { [id: string]: Data[] } {
        return tracking.reduce((result, it) => {
            let dataFiltered: Data[] = this.filterPositionByDataArray(it.data, documentIds);
            if (dataFiltered && dataFiltered.length) {
                return { ...result, [it.vehicle_id]: dataFiltered };
            } else {
                return result;
            }
        }, {});
    }

    filterPositionByDataArray(data: Data[], documentIds: string[]): Data[] {
        return data.filter(d => getIndexFromSimpleList(documentIds, d.document_id) >= 0);
    }

    handleshowLabel(value: boolean) {
        if (value) {
            this.$_showLabel();
        } else {
            this.$_hideLabel();
        }
    }

    @Destroyed
    cancelTokens() {
        if (this.cancelTokenHistoricalData) {
            this.cancelTokenHistoricalData.cancel();
            this.cancelTokenHistoricalData = null;
        }
        if (this.cancelLastReport) {
            this.cancelLastReport.cancel();
            this.cancelLastReport = null;
        }
        if (this.cancelVariablesEnableByVehicles) {
            this.cancelVariablesEnableByVehicles.cancel();
            this.cancelVariablesEnableByVehicles = null;
        }
        if (this.cancelFilterByCompanies) {
            this.cancelFilterByCompanies.cancel();
            this.cancelFilterByCompanies = null;
        }

        if (this.cancelTokenHistoricalDataFromVisualizationApply) {
            this.cancelTokenHistoricalDataFromVisualizationApply.cancel();
            this.cancelTokenHistoricalDataFromVisualizationApply = null;
        }
    }

    showAndHideButtons(value: TypeFilterDate) {
        this.shouldShowLabelDisplayed = value === TypeFilterDate.TR;
    }

    checkEmptyHistoricalData(result: OptionalHistoricalData): void {
        if (result !== null) {
            if (!hasElements(result.tracking)) {
                this.shouldStatsPanelDisplayed = false;
                this.shouldTravelComponentDisplayed = false;
            } else {
                this.checkIfBoundsAreEmpty(result['bounds']);
                this.checkVehiclesThatHasHistoricalData(result.tracking);
                this.shouldStatsPanelDisplayed = true;
                if (!this.shouldGeofenceComponentDisplayed) {
                    this.shouldTravelComponentDisplayed = true;
                }
            }
        }
    }

    checkIfBoundsAreEmpty(responseBounds) {
        this.boundsAreCero = false;
        if (responseBounds !== null) {
            if (
                responseBounds[0]['lat'] == 0 &&
                responseBounds[0]['lng'] == 0 &&
                responseBounds[1]['lat'] == 0 &&
                responseBounds[1]['lng'] == 0
            ) {
                this.boundsAreCero = true;
            }
        }
    }

    checkVehiclesThatHasHistoricalData(data) {
        // this.clearFilter('vehicleSelected');
        this.vehiclesWithHistoricalData = [];
        let vehiclesWithResponseData: any = []; //vehicles with response data
        let vehiclesWithoutData: any = [];
        if (hasElements(data)) {
            for (let i = 0; i < data.length; i++) {
                let vehicleDescription = getVehicleData(data[i].vehicle_id, 'description', this.$_getSelectedVehicles, '');
                this.vehiclesWithHistoricalData.push(vehicleDescription);
                vehiclesWithResponseData.push(data[i].vehicle_id.toString());
            }
            vehiclesWithoutData = this.$_getSelectedVehiclesByID.filter(function(vehicle) {
                return vehiclesWithResponseData.indexOf(vehicle.toString()) == -1;
            });

            for (let i = 0; i < vehiclesWithoutData.length; i++) {
                vehiclesWithoutData[i] = this.getVehiclePlateFromVehicleId(vehiclesWithoutData[i].toString());
            }
            if (vehiclesWithoutData.length == 1) {
                this.$_showParameterError('No hay datos para el vehículo: ' + vehiclesWithoutData);
                this.updateVehiclesParamsInfo(vehiclesWithResponseData);
            } else if (vehiclesWithoutData.length > 1) {
                this.$_showParameterError('No hay datos para los vehículos: ' + vehiclesWithoutData);
                this.updateVehiclesParamsInfo(vehiclesWithResponseData);
            }
        }

        if (this.vehiclesWithHistoricalData.length == 1) {
            this.vehicleSelected = this.vehiclesWithHistoricalData[0];
        }
    }

    @Watch('$_getSelectedVehiclesByID')
    updateVehiclesSelectedFilters() {
        this.setLegend(null);
        this.lastReportResponse = [];
        this.lastReportDataIsFormated = false;
        this.clearVariableDataTab();
        this.resetMultiselectFilters();
        if (this.$_getSelectedVehiclesByID.length == 1) {
            if (this.$_getFilterDate == TypeFilterDate.TR || this.$_getFilterDate == TypeFilterDate.RANGE_DATE) {
                let vs = this.$_getSelectedVehiclesByID.toString();
                this.vehicleSelected = this.getVehiclePlateFromVehicleId(vs);
            }
            this.clearVehSelector = true;
        } else if (this.$_getSelectedVehiclesByID.length == 0) {
            this.shouldStatsPanelDisplayed = false;
        } else {
            this.clearVehSelector = true;
        }
    }

    @Watch('$_getFilterDate')
    @Watch('$_getSelectedVehiclesByID')
    enableActualStatePanel() {
        this.clearHistoricalDtcs();
        this.isUpdatingLastReport = false;
        if (this.$_getFilterDate == TypeFilterDate.TR) {
            if (this.existAnyVehiclesByID()) {
                this.shouldActualStatsPanelDisplayed = true;
            } else {
                this.shouldActualStatsPanelDisplayed = false;
            }
        } else {
            EventBus.$emit(TypeEventBus.FILTER_CHANGED);
        }
    }

    executeSearch() {
        this.boundsCentered = null;
        this.markersTravel = [];
        this.visualizationApply = { markers: [], start: 0, end: -1 };
        this.showAndHideButtons(this.$_getFilterDate);
        if (this.$_getFilterDate === TypeFilterDate.TR) {
            if (!this.$_getOpenStatsPanel) {
                this.shouldActualStatsPanelDisplayed = true;
            } else {
                this.shouldActualStatsPanelDisplayed = true;
            }
            this.$_clearHistoricalMap();
            this.$_clearLastReport();
            if (this.callLastReport) {
                this.executeLastReport(() => {
                    this.clearThread();
                    this.pollThread();
                }, false);
            }
        } else {
            EventBus.$emit(TypeEventBus.CLEAR_MARKERS_DRAW_ROUTES);
            if (this.historicalDataSelection$) {
                if (!this.historicalSubscription) {
                    this.historicalSubscription = this.historicalDataSelection$.subscribe();
                }
            }
            this.ejecuteSearchHistorical$.next();
        }
    }

    executeLastReport(callbck?: Function | null, asyncSearch?: boolean) {
        this.cancelTokens();
        if (this.$_getOpenStatsPanel) {
            this.getCurrentTimestamp = '';
        }
        this.pendingRequestActualState = true;
        const vehicles = hasElements(this.$_getSelectedVehiclesByID)
            ? this.$_getSelectedVehiclesByID
            : this.$_selectVehiclesFromSelectedCompanyById();
        if (vehicles && vehicles.length) {
            this.asyncSearch = asyncSearch ? asyncSearch : false;
            this.$_completeHistoricalRequest();
            this.$_pendingLastReportRequest();
            this.cancelTokens();
            this.cancelLastReport = Axios.CancelToken.source();

            TrackingService.getLastReport(vehicles, this.cancelLastReport, this.$_isMock)
                .then((response: LastReport[]) => {
                    if (hasElements(response)) {
                        this.shouldActualStatsPanelDisplayed = true;
                        // console.clear();
                        // console.log("last_report", response);
                        if (this.$_getOpenStatsPanel) {
                            this.updateActualStatePanel(response);
                            this.pendingRequestActualState = false;
                        }
                    } else {
                        this.lastReportResponse = [];
                        this.shouldActualStatsPanelDisplayed = false;
                    }
                    this.showLoader = false;

                    this.checkEmptyLastReport(response);
                    this.$_setLastReport(response);
                    callbck && callbck();
                    this.$_completeLastReportRequest();
                    this.asyncSearch = false;
                    this.changeVehiclesMarkerEffect();
                })
                .catch(error => {
                    this.asyncSearch = false;
                    this.$_completeLastReportRequest();
                    if (!Axios.isCancel(error)) {
                        if (error.lock) {
                            this.$_showLastReportError(error.lock);
                        }
                    }
                    this.showLoader = false;
                });
        }
    }

    clearThread() {
        clearInterval(this.thread);
        this.thread = null;
    }

    pollThread() {
        if (
            this.$_getFilterDate === TypeFilterDate.TR &&
            !this.$_isMock &&
            this.isFilterVehiclesClose &&
            !this.thread
        ) {
            if (this.callLastReport) {
                this.thread = setInterval(() => {
                    this.isUpdatingLastReport = true;
                    this.executeLastReport(null, true);
                }, this.timeToExecuteLastReport);
            }
        }
    }

    @Destroyed
    hideDrawer() {
        this.drawer = false;
    }

    beforeDestroy() {
        this.updateLocalStorageFilterNow();
        this.clearThread();
        tour.complete();
    }

    handleVariablesResponse(variables) {
        if (this.$_getVariables && hasElements(Object.keys(this.$_getVariables))) {
            this.variables = variables;
        } else {
            this.variables = null;
        }
    }

    get variableChart(): HTMLFormElement {
        return this.$refs.variableChart as HTMLFormElement;
    }

    handlePlayBackInfos(infos: Record<string, PlayBackInfo>) {
        this.infos = infos;
    }

    handleTimeStampInfo(timeStampInfo: string | undefined) {
        this.timeStampInfo = timeStampInfo;
    }

    get pendingRequest(): boolean {
        return this.$_getPendingRequest && !this.asyncSearch;
    }

    showAddFilter({ filter, isFilterSelected }): void {
        this.currentFilter = filter;
        this.isAddFilterVisible = true;
        if (this.currentFilter && isFilterSelected) {
            this.setApplyFilterState(true);
        } else {
            this.setApplyFilterState(false);
        }
    }

    hideAddFilter(): void {
        this.isAddFilterVisible = false;
    }

    handleFilter(value: Date[]) {
        this.$_setTypeFilterDate(TypeFilterDate.RANGE_DATE);
        if (hasElements(value)) {
            this.$_setDateRange({
                datetime_to: getDateByFormat(dateTypes.globalFilterDateFormat, value[1]).toString(),
                datetime_from: getDateByFormat(dateTypes.globalFilterDateFormat, value[0]).toString()
            });
        } else {
            this.$_setDateRange({
                datetime_to: '',
                datetime_from: ''
            });
        }
    }

    get shouldShowFilterComponent(): boolean {
        return this.$_getFilterDate === TypeFilterDate.RANGE_DATE;
    }

    get filterQuickAccess(): any {
        return this.$refs.filterQuickAccess as any;
    }

    handleShowFilterManager(): void {
        const unsubscription = this.getLoadFilter$(
            this.$_getSelectedCompanyById as string,
            Axios.CancelToken.source(),
            this.$_isMock
        ).subscribe(() => {
            unsubscription.unsubscribe();
        });
    }

    applyVisualization(apply: VisualizationApply | null): Promise<HistoricalDataResponse | null> {
        if (apply !== null) {
            this.setLegend(null);
            this.zoomHistorical = 7;
            this.cancelTokenHistoricalDataFromVisualizationApply = Axios.CancelToken.source();
            return TrackingService.filterConditions(
                { ...(this.paramsInfo as HistoricalParams), ...apply },
                this.cancelTokenHistoricalDataFromVisualizationApply
            );
        } else {
            this.visualizationApply = { markers: [], start: 0, end: -1 };
            this.ejecuteSearchHistorical$.next();
            return Promise.resolve(null);
        }
    }

    updateMarkersHistoricalFromVisualizationApply(markers: Marker[]): void {
        this.visualizationApply = this.buildAndFilterVisualizationApply(markers, this
            .filterDateEvent as FilterDateEvent);
        this.centerVisualization(this.visualizationApply);
        this.validateVisualization(this.visualizationApply);
    }

    buildAndFilterVisualizationApply(markers: Marker[], filterDateEvent: FilterDateEvent): VisualizationInfo {
        let start = 0;
        let end = markers.length - 1;
        if (this.existFilterDateEvent(filterDateEvent)) {
            start = this.findStartFilter(markers, filterDateEvent);
            end = this.findEndFilter(markers, filterDateEvent);
        }
        return { markers, start, end };
    }

    validateVisualization(visualization: VisualizationInfo): void {
        if (visualization.start > visualization.end) {
            this.showNoInfoMessage();
        }
    }

    existFilterDateEvent(filterDateEvent: FilterDateEvent | null): boolean {
        return !!(filterDateEvent && filterDateEvent.range);
    }

    setStops() {
        let stopMarkers = {}
        let self = this;
        if (
            this.$store.state.vehicleHistorical &&
            this.$store.state.vehicleHistorical['tracking'] &&
            this.$store.state.vehicleHistorical['tracking'].length !== 0
        ) {
            let historicalMarkers = self.markerVehicleHistorical;
            this.$store.state.vehicleHistorical['tracking'].forEach(element => {
                let vehicleId = element['vehicle_id'];
                let vehicleStops = element['stops'];
                if(
                    hasElements(vehicleStops) &&
                    hasElements(historicalMarkers)
                ){
                    let indexVehicleInHistoricalMarkers = getIndexFromList(historicalMarkers, 'vehicle_id', vehicleId);
                    if(indexVehicleInHistoricalMarkers !== -1){
                        vehicleStops = vehicleStops.map(function(currentStop){
                            return {
                                ...currentStop,
                                color:historicalMarkers[indexVehicleInHistoricalMarkers]['color']
                            }
                        })
                    }
                }
                stopMarkers = {
                    ...stopMarkers,
                    [vehicleId]: vehicleStops
                }
            });
        }
        this.stopMarkers = stopMarkers;
    }

    centerVisualization(visualization: VisualizationInfo): void {
        let isThereFilteredInfo = false;
        let selectedMarkers: Marker[] = [];
        if (visualization.start < visualization.end) {
            if (visualization.start != 0 || visualization.end != visualization.markers.length - 1) {
                isThereFilteredInfo = true;
            }
            selectedMarkers = visualization.markers.slice(visualization.start, visualization.end + 1);
        } else {
            isThereFilteredInfo = true;
            selectedMarkers = [];
        }

        let points = chooseMarkerPositions(selectedMarkers);
        google.maps.event.addListenerOnce(this.map.googleMap, 'zoom_changed', () => {
            this.zoomHistorical = this.map.googleMap.getZoom();
            this.map.googleMap.setZoom(this.zoomHistorical);
            this.shouldShowRemoveSecondFilterButton = isThereFilteredInfo;
        });
        if (hasElements(points)) {
           this.map.setCenter(points)
        } else {
            isThereFilteredInfo = true;
            this.showNoInfoMessage();
            this.mapSetZoomAndCenter(points);
        }
    }

    addLegend(legend: LegendMap): void {
        this.$_addLegend(legend);
    }

    setLegend(legend: LegendMap | null): void {
        if (!this.boundsAreCero) {
            this.$_setLegend(legend);
        }
    }
    setUndefinedState(): void {
        this.playbackState = PlaybackState.UNDEFINED;
    }
    get existIndicesPlaybackData() {
        let arrIndices = this.getVehicleIndices;
        if (JSON.stringify(arrIndices) !== '{}' && JSON.stringify(arrIndices['indices']) !== '{}') {
            return true;
        } 
        return false;
    }

    handlePlaybackButton(shouldTravelComponentDisplayed, drawer): void {
        let _this = this;
        if (!_this.$_isMock) {
            if (!(shouldTravelComponentDisplayed && drawer)) {
                if (!this.existIndicesPlaybackData) {
                    //  console.log("no hay playback data", _this.getVehicleIndices);
                    _this.updatePlaybackIndices(_this.paramsInfo);
                } else {
                    //    console.log("exist playback data", _this.getVehicleIndices);
                    _this.handleTravel();
                }
            } else {
                this.shouldTravelComponentDisplayed = false;
                this.shouldGeofenceComponentDisplayed = false;
                this.drawer = false;
            }
        }
    }

    updatePlaybackIndices(paramsInfo) {
        let _this = this;
        _this.pendingIndices = true;
        TrackingService.getHistoricalDataByIndices(paramsInfo)
            .then((response: any) => {
                _this.getVehicleIndices = response;
                if (JSON.stringify(response['indices']) !== '{}') {
                    _this.handleTravel();
                } else {
                    _this.drawer = false;
                }
                _this.pendingIndices = false;
            })
            .catch(error => {
                _this.getVehicleIndices = {};
                _this.pendingIndices = false;
            });
    }

    handleTravel(): void {
        if (this.drawer && !this.shouldTravelComponentDisplayed) {
            this.shouldGeofenceComponentDisplayed = false;
            this.shouldTravelComponentDisplayed = true;
            this.setCursorLoading();
        } else if (this.drawer && this.shouldTravelComponentDisplayed) {
            this.shouldTravelComponentDisplayed = false;
            if (this.$_existHistoricalData) {
                this.setCursorLoading();
                this.shouldTravelComponentDisplayed = true;
            }
        } else if (!this.drawer) {
            this.setCursorLoading();
            this.shouldTravelComponentDisplayed = true;
            this.shouldGeofenceComponentDisplayed = false;
            this.drawer = true;
        }
    }

    handleGeofence(): void {
        if (this.drawer && !this.shouldGeofenceComponentDisplayed) {
            //in case playback is playing
            if (this.playbackState == PlaybackState.PLAY) {
                this.markersTravel = [];
                this.playbackState = PlaybackState.UNDEFINED;
                this.changeHistoricalMarkersEffect();
            }
            this.shouldGeofenceComponentDisplayed = true;
            this.shouldTravelComponentDisplayed = false;
            this.setCursorLoading();
        } else if (this.drawer && this.shouldGeofenceComponentDisplayed) {
            //hide geofence panel
            this.shouldGeofenceComponentDisplayed = false;
            if (this.$_existHistoricalData) {
                this.shouldTravelComponentDisplayed = true;
            }
            this.drawer = false;
        } else if (!this.drawer) {
            //show geofence panel
            EventBus.$emit(TypeEventBus.FILTER_GEOFENCE_TABLE);
            this.shouldTravelComponentDisplayed = false;
            this.shouldGeofenceComponentDisplayed = true;
            this.setCursorLoading();
            this.drawer = true;
        }
    }

    openStatsPanel(): void {
        this.setCursorLoading();
        this.$_openStatsPanel();
        this.drawer = false;
    }

    setApplyFilterState(value: boolean): void {
        this.cancelFilerSelected = value;
    }

    setMarksPanelDisableListenKey(value: boolean): void {
        this.marksPanelDisableListenKey = value;
    }

    loadDataGeoFences(): void {
        if (this.$_getSelectedCompanyById !== null) {
            this.geoFencesStore.updateLoading(true);
            TrackingService.getGeofenceByCompany(this.$_getSelectedCompanyById as string, this.$_isMock)
                .then((response: any) => {
                    this.geoFencesStore.updateLoading(false);
                    let geofencesKeys = Object.keys(response.geofence_types);
                    let geofencesChoices = Object.values(response.geofence_types);
                    this.geofencesTypes = [];
                    if (this.geofencesTypes.length == 0) {
                        for (let i = 0; i < geofencesKeys.length; i++) {
                            this.geofencesTypes.push({
                                id: parseInt(geofencesKeys[i]),
                                value: geofencesChoices[i],
                                checked: false
                            });
                        }
                        this.geofencesTypes.push({
                            id: 9999,
                            value: 'Genérica',
                            checked: false
                        });
                    }
                    this.$_setGeofencesType(this.geofencesTypes);
                    this.$_setGeofencesFilter(this.geofencesTypes);
                    this.geoFencesStore.setElements(response.geofences);
                    this.geoFencesStore.setSelected(response.geofences);
                })
                .catch(error => {
                    this.resetGeofenceFilter();
                    this.$_catchLoadingDialog({
                        response: error.response.data || {},
                        alternative_msg: getGeofenceError
                    })
                    this.geoFencesStore.updateLoading(false);
                });
        }
    }

    resetGeofenceFilter() {
        this.$_setGeofencesType([]);
        this.$_setGeofencesFilter([]);
        this.geoFencesStore.setElements([]);
        this.geoFencesStore.setSelected([]);
    }

    loadPointsOfInterest(): void {
        if (this.$_getSelectedCompanyById !== null) {
            this.pointStore.updateLoading(true);
            TrackingService.getPointsOfInterestByCompany(this.$_getSelectedCompanyById as string, this.$_isMock)
                .then((response: PointsOfInterest[]) => {
                    this.pointStore.updateLoading(false);
                    this.pointStore.setElements(response);
                    this.pointStore.setSelected(response);
                })
                .catch(error => {
                    let message =
                        error && error.response && error.response.data && error.response.data.message
                            ? error.response.data.message
                            : '';
                    if (message !== '') {
                        this.$_errorDeleteGeofences(message);
                    }
                    this.pointStore.updateLoading(false);
                });
        }
    }

    handleCenter(point: Point | Point[]): void {
        if (Array.isArray(point)) {
            this.mapSetZoomAndCenter(point);
        } else {
            this.mapSetZoomAndCenter([point]);
        }
    }

    get filterDialog(): any {
        return this.$refs.filterDialog as any;
    }

    handleChangeVisibleMenu(value: boolean): void {
        this.addPointVisible = value;
    }

    handleChangeVisibleGeoFenceMenu(value: boolean): void {
        this.addGeoFenceVisible = value;
    }

    handleAddAndSelectPointOfInterest(point: PointsOfInterest): void {
        if (point) {
            this.pointStore.addElement(point);
            this.pointStore.addSelected(point);
        }
        this.$_overWait();
        this.map.listenAddOrEditElementOff();
    }

    handleAddAndSelectGeoFence(geoFence: Geofence): void {
        if (geoFence) {
            this.geoFencesStore.addElement(geoFence);
            this.geoFencesStore.addSelected(geoFence);
            this.$_overWait();
            this.map.listenAddOrEditElementOff();
        }
    }

    handleEditAndSelectPointOfInterest(point: PointsOfInterest): void {
        if (point) {
            this.pointStore.editElement(point, 'point_of_interest_id');
        }
        this.$_overWait();
        this.map.listenAddOrEditElementOff();
    }

    handleEditAndSelectGeoFence(geoFence: Geofence): void {
        if (geoFence) {
            this.geoFencesStore.editElement(geoFence, 'geofence_id');
        }
        this.$_overWait();
        this.map.listenAddOrEditElementOff();
    }

    handleWaitForAddPoint(): void {
        this.$_waitForElementAddition();
        this.map.listenAddPoint();
    }

    handleWaitForAddGeoFence(): void {
        this.$_waitForElementAddition();
        this.map.listenAddGeoFence();
    }

    handleWaitForEditPoint(point: PointsOfInterest): void {
        this.$_waitForElementAddition();
        this.map.listenEditPoint(point);
    }

    handleWaitForEditGeoFence(geoFence: Geofence): void {
        this.$_waitForElementAddition();
        this.map.listenEditGeoFence(geoFence);
    }

    get existAnyElementVisible(): boolean {
        return !(!hasElements(this.pointStore.getSelected()) && !hasElements(this.geoFencesStore.getSelected()));
    }

    @Watch('showAlertSampling')
    watchSamplingAlert(value) {
        if (value) {
            this.hideGeofencesAndPoints();
        }
    }

    handleVisibleElements(): void {
        if (this.existAnyElementVisible) {
            this.hideGeofencesAndPoints();
        } else {
            this.geoFencesStore.setSelected(this.geoFencesStore.getElements());
            this.pointStore.setSelected(this.pointStore.getElements());
        }
    }

    hideGeofencesAndPoints() {
        this.geoFencesStore.setSelected([]);
        this.pointStore.setSelected([]);
    }

    setCursorLoading(): void {
        this.$_setLoadingCursor(true);
    }

    setCursorDefault(): void {
        this.$_setLoadingCursor(false);
    }

    handlePanelOpen(): void {
        this.setCursorDefault();
    }

    @Watch('shouldGeofenceComponentDisplayed')
    observerShouldGeofenceComponentDisplayed(value: boolean): void {
        if (!value) {
            //this.map.setZoomAndCenterMergeMap();
        }
    }

    @Watch('drawer')
    observerDrawer(value: boolean) {
        if (!value) {
            this.markersTravel = [];
            if (this.playbackState === PlaybackState.UNDEFINED) {
                this.changeHistoricalMarkersEffect();
            }
            this.playbackState = PlaybackState.UNDEFINED;
        } else {
            this.playbackSpeed = 500;
            if (this.$_getOpenStatsPanel) {
                this.statsPanel.toggleMinimizeState();
            }
        }
    }

    @Watch('$_getDateRange')
    observableGetDateForm(value: DateRange) {
        this.markersTravel = [];
        this.markers = [];
        this.markerVehicleHistorical = [];
        this.zoomHistorical = 7;
        this.playbackState = PlaybackState.UNDEFINED;
        this.changeHistoricalParamsEffect();
        this.resetZoomAndCenter();
        if (value.datetime_to && value.datetime_from) {
            this.executeSearch();
        } else {
            this.$_setHistoricalMap(null);
        }
    }

    @Watch('$_getFilterDate')
    observableGetFilterDate(value: number) {
        if (this.$_getOpenStatsPanel) {
            if (this.variableChart && this.$_getDateRange.datetime_from && this.$_getDateRange.datetime_to) {
                this.variableChart.reloadVariableChartsFromFilterDate();
            }
        }
        this.clearVariableDataTab();
        this.clearThread();
        this.showAndHideButtons(value);
        this.markers = [];
        this.markerVehicleHistorical = [];
        this.chartMin = -1;
        this.chartMax = -1;
        this.zoomHistorical = 7;
        this.checkIfExistAnyVehicleSelected();
        this.changeHistoricalParamsEffect();
        this.resetZoomAndCenter();
        this.variables = null;
        this.setLegend(null);
        this.handleRemoveSecondFilter();
        if (this.$_getOpenStatsPanel && !this.variableSelectedInPanel) {
            this.statsPanel.toggleMinimizeState();
        }
        // this.filterQuickAccess.handleApplyVisualization(null, null);
        if (value == 3) {
            this.setLocalStorageFilterNow();
            this.drawer = false;
            this.shouldTravelComponentDisplayed = false;
            this.shouldStatsPanelDisplayed = false;
            this.shouldGeofenceComponentDisplayed = false;
            if (this.historicalSubscription) {
                this.historicalSubscription.unsubscribe();
                this.historicalSubscription = null;
            }
            this.runSearchWhenFilterDateChange && this.executeSearch();
            this.runSearchWhenFilterDateChange = true;
            this.clearVehicleSelected();
        } else if (value == 1 || value == 0) {
            this.updateLocalStorageFilterNow();
            this.$_clearLastReport();
            this.executeSearch();
        } else {
            this.updateLocalStorageFilterNow();
            this.$_clearLastReport();
        }
    }

    checkIfExistAnyVehicleSelected() {
        if (this.$_getSelectedVehiclesByID.length == 0 && this.$_getFilterDate !== TypeFilterDate.TR) {
            if (this.$route.name === 'travel' && this.pageMounted) {
                this.$_showHistoricalError('No hay ningún vehículo seleccionado');
            }
            this.showLoader = false;
        }
    }

    resetZoomAndCenter(){
        if(this.map){
             this.map.resetForceZoomAndCenter();
        }
    }

    @Watch('$_getSelectedCompany')
    observableSelectedCompany(value) {
        this.applyVisualization(null);
        this.resetGeofenceFilter();
        this.$_setSelectedVehicles([]);
        this.drawer = false;
        this.variables = null;
        this.filters = [];
        this.resetZoomAndCenter();
        if (!this.$_getQueryParams['hasParams'] && this.$_getFilterDate !== TypeFilterDate.TR) {
            this.runSearchWhenFilterDateChange = false;
            this.$_setTypeFilterDate(TypeFilterDate.TR);
        }
        if (!hasElements(this.$_getSelectedVehiclesByID)) {
            this.executeSearch();
        }
        this.loadDataGeoFences();
        this.loadPointsOfInterest();
    }

    toggleExpandStatsPanel(action) {
        this.expandedPanel = action;
    }

    @Watch('$_getOpenStatsPanel')
    observeGetOpenStatsPanel(value: boolean) {
        EventBus.$emit(TypeEventBus.RESET_TAB_POSITION);
        if (value && this.variableChart) {
            if (
                !this.$_getDateRange.datetime_from &&
                !this.$_getDateRange.datetime_to &&
                this.$_getFilterDate == TypeFilterDate.RANGE_DATE
            ) {
                this.variableChart.clearSeries();
            }
            // this.variableChart.selectFirstVariable();
            this.setCursorDefault();
        }

        if (this.$_getFilterDate == TypeFilterDate.TR) {
            if (value) {
                this.executeLastReport(null, true);
            }
            // this.actualStatsPanelCenterAndZoom(this.markers);
        } else {
            if (hasElements(this.visualizationApply.markers)) {
                this.centerVisualization(this.visualizationApply);
            } else {
                if (this.$_existHistoricalData) {
                    this.changeHistoricalMarkersEffect();
                }
            }
        }
    }

    @Destroyed
    unSubscribe(): void {
        this.unSubscribe$.next();
        this.unSubscribe$.complete();
        this.getVehicleIndices = {};
    }
}
